{
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "retry": "Retry",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "close": "Close",
    "back": "Back",
    "next": "Next",
    "search": "Search",
    "watchNow": "Watch Now",
    "playNow": "Play Now",
    "play": "Play",
    "moreInfo": "More Info",
    "seeAll": "See All",
    "new": "New",
    "live": "LIVE",
    "recommended": "Recommended",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "invalidDate": "Invalid Date",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "Your Home. Anywhere.",
    "ok": "OK",
    "success": "Success",
    "warning": "Warning",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "apply": "Apply",
    "errors": {
      "unexpected": "An unexpected error occurred"
    },
    "send": "Send",
    "done": "Done",
    "all": "All",
    "reset": "Reset",
    "deleting": "Deleting...",
    "noResults": "No results found",
    "tryDifferentSearch": "Try a different search term",
    "previous": "Previous",
    "actions": "Actions",
    "pageOf": "Page {{page}} of {{total}}",
    "noData": "No data available",
    "filters": "Filters",
    "clear": "Clear",
    "clearSelection": "Clear",
    "expand": "Expand",
    "collapse": "Collapse",
    "upgrade": "Upgrade to Premium",
    "skip": "Skip",
    "thisContent": "this content",
    "backToHome": "Back to Home",
    "dismiss": "Dismiss",
    "goBack": "Go Back",
    "pause": "Pause",
    "tryAgain": "Try Again",
    "refresh": "Refresh"
  },
  "culturalContext": {
    "loading": "Loading explanation...",
    "loadError": "Failed to load explanation",
    "related": "Related References"
  },
  "demo": {
    "banner": "DEMO MODE",
    "bannerSubtext": "Using mock data - No API calls",
    "days": {
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday"
    },
    "shabbat": "Shabbat",
    "until_shabbat": "Until Shabbat",
    "search_interpretation": "Search for \"{{query}}\"",
    "suggestions": {
      "0": "Fauda",
      "1": "Shtisel",
      "2": "Tehran",
      "3": "The Arbitrator",
      "4": "Labour"
    },
    "premium_plan": "Premium",
    "assistant_response": "I recommend Fauda - an excellent thriller series!",
    "morning_greeting": "Good morning! Today the weather is nice, there are some important news from Israel, and I've selected content especially for you."
  },
  "hero": {
    "watch": "Watch",
    "moreInfo": "More Info",
    "addToList": "Add to List"
  },
  "login": {
    "title": "Welcome Back",
    "subtitle": "Sign in to continue to Bayit+",
    "tagline": "Your Home in the USA",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "submit": "Sign In",
    "loggingIn": "Signing in...",
    "or": "or",
    "forgotPassword": "Forgot password?",
    "continueWithGoogle": "Continue with Google",
    "noAccount": "Don't have an account?",
    "signUp": "Sign Up",
    "register": "Register",
    "name": "Name",
    "termsNotice": "By signing in, you agree to our Terms of Service and Privacy Policy",
    "errors": {
      "emailRequired": "Email is required",
      "passwordRequired": "Password is required",
      "loginFailed": "Login failed. Please check your credentials.",
      "googleFailed": "Google sign-in failed. Please try again.",
      "fillAllFields": "Please fill in all fields"
    },
    "qrInstructions": "Scan the code with your phone for quick login",
    "methodQR": "QR Code",
    "methodVoice": "Voice",
    "methodTraditional": "Email",
    "qrTitle": "Scan to Login",
    "qrDescription": "Scan this QR code with your phone to login without typing",
    "expiresIn": "Expires in 5 minutes",
    "companionConnected": "Phone connected!",
    "authenticating": "Logging you in...",
    "sessionExpired": "Session expired",
    "refreshQR": "Generate New Code",
    "generatingQR": "Generating QR code...",
    "howItWorks": "How it works:",
    "step1": "Open camera on your phone",
    "step2": "Scan the QR code above",
    "step3": "Login on your phone",
    "step4": "TV logs in automatically!",
    "voicePlaceholder": "Type your response...",
    "send": "Send",
    "createAccount": "Create Account",
    "bayitThinking": "Bayit is thinking...",
    "unexpectedError": "An unexpected error occurred"
  },
  "tvLogin": {
    "invalidQR": "Invalid QR code. Please scan again from your TV.",
    "sessionInvalid": "This QR code has expired. Please generate a new one on your TV.",
    "verificationFailed": "Failed to verify session. Please try again.",
    "fillAllFields": "Please fill in all fields",
    "loginFailed": "Login failed. Please check your credentials.",
    "notLoggedIn": "You are not logged in on this device.",
    "enterCredentials": "Please enter your credentials to authorize your TV.",
    "authFailed": "Authorization failed.",
    "verifying": "Verifying...",
    "verifyingDescription": "Connecting to your TV...",
    "loginTitle": "Login to Your TV",
    "loginDescription": "Enter your credentials to authorize your TV",
    "authorizing": "Authorizing...",
    "authorizingDescription": "Logging you in on your TV...",
    "authorizeTV": "Authorize TV",
    "success": "Success!",
    "successDescription": "Your TV is now logged in. You can close this page.",
    "goToHome": "Go to Home",
    "error": "Something went wrong",
    "tryAgain": "Try Again",
    "securityNote": "Your credentials are sent securely and are never stored on the TV.",
    "footer": "Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "Almost there!",
    "authenticating": "Authenticating...",
    "connected": "Connected",
    "expired": "Code Expired",
    "expiredMessage": "Your sign-in code has expired. Please request a new one.",
    "header": "Sign In to TV",
    "pleaseSignIn": "Please sign in on your phone or computer",
    "signInButton": "Sign In",
    "signInToTV": "Sign In to TV",
    "subtitle": "Enter the code shown on your TV screen",
    "tvSignedIn": "TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "Google sign-in was cancelled",
    "missingCode": "Authentication code is missing",
    "loginError": "Error signing in with Google",
    "redirecting": "Redirecting to login page...",
    "connecting": "Connecting with Google..."
  },
  "register": {
    "title": "Create Account",
    "subtitle": "Join Bayit+ to watch your favorite content",
    "name": "Full Name",
    "namePlaceholder": "John Doe",
    "email": "Email",
    "emailPlaceholder": "your@email.com",
    "password": "Password",
    "passwordPlaceholder": "At least 8 characters",
    "confirmPassword": "Confirm Password",
    "confirmPasswordPlaceholder": "Enter password again",
    "submit": "Sign Up",
    "registering": "Signing up...",
    "acceptTerms": "I agree to the",
    "termsOfService": "Terms of Service",
    "and": "and",
    "privacyPolicy": "Privacy Policy",
    "continueWithGoogle": "Sign up with Google",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in",
    "fullName": "Full Name",
    "loginLink": "Login",
    "placeholders": {
      "fullName": "John Doe",
      "email": "your@email.com",
      "password": "At least 8 characters",
      "confirmPassword": "Enter password again"
    },
    "errors": {
      "nameRequired": "Name is required",
      "emailRequired": "Email is required",
      "passwordRequired": "Password is required",
      "passwordTooShort": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match",
      "acceptTerms": "You must accept the Terms of Service and Privacy Policy",
      "fillAllFields": "Please fill in all fields",
      "registrationFailed": "Registration failed. Please try again.",
      "googleFailed": "Sign up with Google failed. Please try again."
    }
  },
  "nav": {
    "home": "Home",
    "vod": "VOD",
    "liveTV": "Live TV",
    "epg": "TV Guide",
    "radio": "Radio",
    "podcasts": "Podcasts",
    "flows": "Flows",
    "judaism": "Judaism",
    "children": "Kids",
    "profile": "Profile",
    "search": "Search",
    "settings": "Settings",
    "favorites": "Favorites",
    "watchlist": "Watchlist",
    "downloads": "Downloads",
    "recordings": "My Recordings",
    "widgets": "Widgets",
    "help": "Help & Support",
    "discover": "Discover",
    "account": "Account",
    "subscribe": "Subscribe",
    "plans": "Plans",
    "admin": "Admin",
    "games": "Games",
    "friends": "Friends",
    "glossary": "Glossary",
    "missions": "Missions",
    "audiobooks": "Audiobooks",
    "playlist": "Playlist",
    "zehAniHub": "Zeh Ani",
    "support": "Support",
    "discoverHub": "Discover AI",
    "listen": "Listen",
    "byoc": "My Sources",
    "household": "Household",
    "messages": "Messages",
    "myContent": "My Content",
    "social": "Social"
  },
  "epg": {
    "title": "TV Guide",
    "subtitle": "Browse live TV programming schedule",
    "gridView": "Grid View",
    "listView": "List View",
    "israelTime": "Israel Time",
    "localTime": "Local Time",
    "il": "IL",
    "local": "Local",
    "jumpToNow": "Jump to Now",
    "goBack": "← {{hours}}h",
    "goForward": "{{hours}}h →",
    "toggleTimezone": "Toggle Timezone",
    "errorTitle": "Failed to Load TV Guide",
    "errorLoading": "Could not load TV guide data",
    "noPrograms": "No programs found",
    "noChannels": "No channels available",
    "recordProgram": "Record Program",
    "channel": "Channel",
    "enableSubtitles": "Enable Subtitles",
    "subtitleLanguage": "Subtitle Language",
    "storageEstimate": "Storage Estimate",
    "availableSpace": "Available Space",
    "lowStorage": "Low Storage Warning",
    "lowStorageMessage": "You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "Schedule Recording",
    "scheduledRecordingNotSupported": "Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "Failed to start/schedule recording",
    "smartSearch": "Smart Search",
    "smartSearchSubtitle": "Ask questions in natural language",
    "smartSearchPlaceholder": "e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "Search programs, channels, actors...",
    "premiumRequired": "Premium Feature",
    "premiumRequiredMessage": "Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "Search with AI",
    "searching": "Searching...",
    "tryThese": "Try these examples",
    "exampleQuery1": "Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "What comedy shows are airing this week?",
    "exampleQuery3": "Find documentaries about history on Channel 11",
    "exampleQuery4": "Show me all news programs tomorrow morning",
    "aiDisclaimer": "Powered by Claude AI. Results may vary based on program data availability.",
    "interpretationTitle": "What I understood",
    "noResultsFound": "No programs found matching your query"
  },
  "home": {
    "continueWatching": "Continue Watching",
    "featuredContent": "Featured",
    "liveTV": "Live TV",
    "allChannels": "All Channels",
    "liveChannels": "Live Channels",
    "showOnlyWithSubtitles": "Show only with subtitles",
    "israeliMovies": "Israeli Movies",
    "israeli-movies": "Israeli Movies",
    "israeli-series": "Israeli Series",
    "action": "Action & Thriller",
    "comedy": "Comedy",
    "drama": "Drama",
    "documentaries": "Documentaries",
    "loadingContent": "Loading content...",
    "liveNow": "Live Now",
    "trendingInIsrael": "Trending in Israel",
    "jerusalemConnection": "Jerusalem Connection",
    "telAvivConnection": "Tel Aviv Connection",
    "categories": "Categories",
    "nearYou": "Israelis Near You",
    "betaExclusive": "Beta Exclusive",
    "carousel": {
      "fauda": {
        "title": "Fauda",
        "subtitle": "Season 4 - Now Streaming",
        "description": "The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "Shtisel",
        "subtitle": "All Seasons Available",
        "description": "Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "Tehran",
        "subtitle": "Season 2",
        "description": "A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "Live - Kan 11",
        "subtitle": "Watch Now",
        "description": "News, current affairs and quality content"
      }
    },
    "enableLocation": "Enable Location",
    "locationPermissionDeniedDescription": "Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "Allow location access to discover content near you.",
    "openSettings": "Open Settings"
  },
  "search": {
    "title": "Search",
    "subtitle": "Find movies, series, channels, radio stations and podcasts",
    "placeholder": "Search for content...",
    "voicePlaceholder": "Speak now...",
    "searching": "Searching...",
    "listening": "Listening...",
    "noResults": "No results found",
    "noResultsHint": "Try different keywords or change your filters",
    "tryDifferent": "Try different search terms",
    "resultsFor": "results for",
    "resultsFound": "{{count}} results found for \"{{query}}\"",
    "recentSearches": "Recent Searches",
    "clearAll": "Clear All",
    "trending": "Trending Searches",
    "promptTitle": "What are you looking for?",
    "promptDescription": "Search for your favorite content or use voice search",
    "filters": {
      "all": "All",
      "vod": "Movies & Series",
      "live": "Channels",
      "radio": "Radio",
      "podcast": "Podcasts",
      "moviesAndSeries": "Movies & Series",
      "channels": "Channels",
      "podcasts": "Podcasts"
    },
    "suggestions": {
      "movies": "Movies",
      "series": "Series",
      "liveTV": "Live TV",
      "news": "News",
      "sports": "Sports",
      "kids": "Kids"
    }
  },
  "liveTV": {
    "title": "Live TV",
    "channels": "Channels",
    "nowPlaying": "Now Playing",
    "loadError": "Failed to load channels",
    "categories": {
      "all": "All",
      "news": "News",
      "sports": "Sports",
      "entertainment": "Entertainment",
      "kids": "Kids",
      "documentary": "Documentary"
    }
  },
  "listen": {
    "title": "Listen",
    "subtitle": "Radio, Podcasts & Audiobooks",
    "tab": {
      "radio": "Radio",
      "podcasts": "Podcasts",
      "audiobooks": "Audiobooks"
    }
  },
  "radio": {
    "title": "Radio",
    "categories": {
      "all": "All",
      "music": "Music",
      "news": "News",
      "talk": "Talk",
      "jewish": "Jewish"
    },
    "noStations": "No radio stations available",
    "tryLater": "Try again later",
    "playing": "PLAYING",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "Podcasts",
    "episodes": "episodes",
    "categories": {
      "all": "All",
      "general": "General",
      "news": "News",
      "politics": "Politics",
      "tech": "Tech",
      "business": "Business",
      "jewish": "Jewish",
      "entertainment": "Entertainment",
      "sports": "Sports",
      "history": "History",
      "educational": "Educational"
    },
    "noPodcasts": "No podcasts available",
    "tryLater": "Try again later",
    "playLatest": "Play Latest"
  },
  "vod": {
    "title": "Movies & Series",
    "movies": "Movies",
    "series": "Series",
    "searchPlaceholder": "Search movies and series...",
    "noMovies": "No movies found",
    "noSeries": "No series found",
    "loadError": "Failed to load content",
    "showOnlyWithSubtitles": "Show only with subtitles",
    "categories": {
      "all": "All",
      "drama": "Drama",
      "comedy": "Comedy",
      "action": "Action",
      "documentary": "Documentary",
      "kids": "Kids"
    },
    "allCategories": "All",
    "emptyTitle": "No Content Available",
    "emptyDescription": "Try selecting another category",
    "allContent": "All Content",
    "noContent": "No content available",
    "noContentInCategory": "No content found in this category"
  },
  "account": {
    "title": "My Account",
    "profile": "Profile",
    "settings": "Settings",
    "subscription": "Subscription",
    "manageSubscription": "Manage Subscription",
    "personalDetails": "Personal Details",
    "billing": "Billing & Payment",
    "logout": "Logout",
    "login": "Login",
    "register": "Register",
    "email": "Email",
    "password": "Password",
    "name": "Name",
    "guest": "Guest",
    "premium": "Premium",
    "basic": "Basic"
  },
  "flows": {
    "title": "Flows",
    "subtitle": "Personalized content experiences for every moment",
    "activeNow": "Active Now",
    "start": "Start",
    "skipToday": "Skip Today",
    "systemFlows": "Ready-Made Flows",
    "customFlows": "My Flows",
    "system": "System",
    "noCustomFlows": "No custom flows yet",
    "createHint": "Create your first personalized flow",
    "createCustom": "Create Custom Flow",
    "createFlow": "Create Flow",
    "editFlow": "Edit Flow",
    "type": "Type",
    "systemFlow": "System Flow",
    "customFlow": "Custom Flow",
    "schedule": "Schedule",
    "content": "Content",
    "items": "items",
    "aiGenerated": "AI Generated",
    "autoPlay": "Auto Play",
    "aiEnabled": "AI Curation",
    "shabbatTrigger": "Shabbat Evening",
    "manual": "Manual",
    "flowName": "Flow Name",
    "flowNamePlaceholder": "e.g., My Morning Routine",
    "description": "Description",
    "descriptionPlaceholder": "What is this flow for?",
    "startTime": "Start Time",
    "endTime": "End Time",
    "actions": "Actions",
    "details": "Details",
    "createFlowDesc": "Design your personalized content experience",
    "editFlowDesc": "Update your flow settings and content",
    "basicInfo": "Basic Information",
    "options": "Options",
    "autoPlayDesc": "Automatically play next item when current one ends",
    "aiEnabledDesc": "Let AI curate content based on your preferences",
    "startFlow": "Start Flow",
    "deleteFlow": "Delete Flow",
    "custom": "Custom",
    "morning": "Morning",
    "evening": "Evening",
    "shabbat": "Shabbat",
    "addContent": "Add Content",
    "contentPicker": {
      "title": "Add Content to Flow",
      "tabs": {
        "live": "Live TV",
        "radio": "Radio",
        "vod": "On Demand",
        "podcast": "Podcasts"
      },
      "search": "Search content...",
      "selected": "{{count}} selected",
      "addSelected": "Add Selected",
      "noResults": "No content found",
      "alreadyAdded": "Already in flow",
      "loadMore": "Load More"
    },
    "flowItems": {
      "title": "Flow Content",
      "empty": "No content yet. Click Add Content to get started.",
      "count": "{{count}} items",
      "remove": "Remove",
      "moveUp": "Move Up",
      "moveDown": "Move Down",
      "order": "Order",
      "confirmRemove": "Click again to confirm removal",
      "maxReached": "Maximum {{max}} items reached",
      "more": "more items"
    },
    "days": {
      "sunday": "Sunday",
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sundayShort": "Sun",
      "mondayShort": "Mon",
      "tuesdayShort": "Tue",
      "wednesdayShort": "Wed",
      "thursdayShort": "Thu",
      "fridayShort": "Fri",
      "saturdayShort": "Sat",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "title": "Active Days",
      "everyday": "Every day",
      "everyDay": "Every day",
      "weekdays": "Weekdays",
      "weekends": "Weekends",
      "noneSelected": "No days selected",
      "selectedCount": "{{count}} days selected"
    },
    "trigger": {
      "type": "Trigger Type",
      "time": "Time-based",
      "shabbat": "Shabbat Evening",
      "holiday": "Holiday",
      "skipShabbat": "Skip on Shabbat",
      "skipShabbatDesc": "Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "Minutes before candle lighting",
      "shabbatOffsetDesc": "How many minutes before Shabbat should this flow start?",
      "calculatedTime": "Calculated time",
      "thisWeek": "This week: {{day}} at {{time}}",
      "comingSoon": "Holiday triggers coming soon",
      "locationBased": "Times based on your location"
    },
    "examples": {
      "title": "Example Flows",
      "subtitle": "Tap to use as a template",
      "morningRoutine": {
        "name": "Morning Routine",
        "desc": "Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "Evening Wind Down",
        "desc": "Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "Shabbat Preparation",
        "desc": "Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "Coffee Break",
        "desc": "Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "Sunset Vibes",
        "desc": "Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "AI Brief",
    "aiBriefDesc": "Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "AI Brief Enabled",
    "validation": {
      "nameRequired": "Flow name is required",
      "startTimeRequired": "Start time is required",
      "endTimeRequired": "End time is required",
      "timeRange": "End time must be after start time",
      "daysRequired": "Select at least one day",
      "contentRequired": "Add content or enable AI"
    },
    "tv": {
      "useCompanion": "For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "My Profile",
    "profileDetails": "Profile Details",
    "name": "Name",
    "notSet": "Not set",
    "email": "Email",
    "editProfile": "Edit Profile",
    "notificationSettings": "Notification Settings",
    "security": "Security",
    "changePassword": "Change Password",
    "updatePassword": "Update your password",
    "connectedDevices": "Connected Devices",
    "manageDevices": "Manage devices connected to your account",
    "twoFactorAuth": "Two-Factor Authentication",
    "addExtraSecurity": "Add an extra layer of security",
    "address": {
      "line1": "123 Main Street",
      "line2": "Tel Aviv, Israel 6100000"
    },
    "free": "Free",
    "premiumPrice": "$7.99/month",
    "familyPrice": "$12.99/month",
    "remaining": "remaining",
    "tabs": {
      "personal": "Personal",
      "overview": "Overview",
      "subscription": "Subscription",
      "notifications": "Notifications",
      "security": "Security",
      "ai": "AI & Voice",
      "voice": "Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "Current Plan",
      "renewsOn": "Renews on",
      "manageSubscription": "Manage Subscription",
      "cancelSubscription": "Cancel Subscription",
      "noActivePlan": "No active subscription",
      "selectPlan": "Select a Plan"
    },
    "notifications": "Notifications",
    "ai": {
      "title": "AI & Personalization",
      "description": "Configure AI-powered features",
      "assistant": "AI Assistant",
      "assistantDesc": "Personalized recommendations and help",
      "chatbot": "AI Assistant",
      "chatbotEnabled": "Enable AI Assistant",
      "chatbotEnabledDesc": "Get help navigating content",
      "saveHistory": "Save Conversation History",
      "saveHistoryDesc": "Remember previous conversations",
      "recommendations": "Recommendations",
      "personalizedRecs": "Personalized Recommendations",
      "personalizedRecsDesc": "Content suggestions based on history",
      "privacy": "Privacy & Data",
      "privacyDesc": "Your data is encrypted and secure",
      "dataConsent": "Usage Analytics",
      "dataConsentDesc": "Help improve AI features",
      "privacyNote": "Your data is encrypted and secure"
    },
    "voice": {
      "title": "Voice Control",
      "description": "Hands-free navigation",
      "enabled": "Voice Commands",
      "enabledDesc": "Control the app with your voice",
      "tts": "Text-to-Speech",
      "ttsDesc": "AI responses read aloud",
      "wakeWord": "Wake Word Detection",
      "wakeWordDesc": "Say \"Bayit\" to activate",
      "operationMode": "Operation Mode",
      "operationModeDesc": "Choose how you interact with the app",
      "voiceSearch": "Voice Search",
      "voiceSearchEnabled": "Enable voice search",
      "voiceSearchEnabledDesc": "Search for content using your voice",
      "constantListening": "Always Listening Mode",
      "constantListeningDesc": "Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "Audio is only sent to servers when speech is detected",
      "holdButtonMode": "Hold Button to Talk",
      "holdButtonModeDesc": "Press and hold the microphone button instead of always listening",
      "sensitivity": "Voice Detection Sensitivity",
      "sensitivityDesc": "Adjust how responsive the voice detection is",
      "sensitivityLow": "Low (fewer false triggers)",
      "sensitivityMedium": "Medium (balanced)",
      "sensitivityHigh": "High (most responsive)",
      "silenceThreshold": "Silence Detection",
      "silenceThresholdDesc": "How long to wait after speaking before processing",
      "language": "Voice language",
      "accessibility": "Accessibility",
      "autoSubtitle": "Auto-enable subtitles",
      "autoSubtitleDesc": "Automatically show subtitles when playing content",
      "highContrast": "High contrast mode",
      "highContrastDesc": "Increase contrast for better visibility",
      "textSize": "Text size",
      "textSizeSmall": "Small",
      "textSizeMedium": "Medium",
      "textSizeLarge": "Large",
      "voiceOnlyInfo": "Voice Only Mode",
      "voiceOnlyDetails": "Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "Hybrid Mode",
      "hybridDetails": "Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "Classic Mode",
      "classicDetails": "All voice features disabled. Remote control only.",
      "textToSpeech": "Voice Responses",
      "ttsEnabled": "Enable voice responses",
      "ttsEnabledDesc": "App will speak responses to your voice commands",
      "ttsVolume": "Voice Volume",
      "ttsSpeed": "Speaking Speed",
      "hybridFeedback": "Interactive Feedback",
      "voiceFeedback": "Voice feedback on actions",
      "voiceFeedbackDesc": "Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "My Profile",
      "subscription": "Subscription",
      "favorites": "Favorites",
      "downloads": "Downloads",
      "signOut": "Sign Out"
    },
    "guest": "Guest",
    "morningRitual": "Morning Ritual",
    "watchlist": "Watchlist",
    "favorites": "Favorites",
    "downloads": "Downloads",
    "settings": "Settings",
    "language": "Language",
    "admin": "Admin",
    "watchTime": "Watch Time",
    "minutes": "minutes",
    "hours": "hours",
    "logout": "Log Out",
    "premium": "Premium",
    "basic": "Basic",
    "upgrade": "Upgrade to Premium",
    "memberSince": "Member since",
    "aiAssistant": "AI Assistant",
    "voiceSettings": "Voice",
    "subscriptionButton": "Subscription",
    "recentActivity": "Recent Activity",
    "justNow": "Just now",
    "hoursAgo": "{{hours}} hours ago",
    "yesterday": "Yesterday",
    "noRecentActivity": "No recent activity",
    "accountInfo": "Account Information",
    "role": "Role",
    "accountSecurity": "Account Security",
    "securityNote": "Your account is secured with encrypted authentication",
    "lastLogin": "Last login",
    "dangerZone": "Danger Zone",
    "invalidImageType": "Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "Avatar updated successfully!",
    "uploadFailed": "Failed to upload avatar. Please try again.",
    "complimentaryPremium": "COMPLIMENTARY PREMIUM ACCESS",
    "emailVerified": "Email verified",
    "emailUnverified": "Email not verified",
    "phoneVerified": "Phone verified",
    "phoneUnverified": "Phone not verified",
    "completeVerification": "Complete verification to unlock all features",
    "unlockPremium": "Unlock Premium Features",
    "unlockPremiumDescription": "Upgrade to enjoy exclusive content and features"
  },
  "voiceMode": {
    "voiceOnly": "Voice Only",
    "voiceOnlyDesc": "No remote control - full voice navigation",
    "hybrid": "Hybrid",
    "hybridDesc": "Voice + Remote - voice feedback on actions",
    "classic": "Classic",
    "classicDesc": "No voice - remote control only"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "appLanguage": "App Language",
    "selectLanguage": "Select Language",
    "languages": {
      "en": "English",
      "he": "עברית",
      "es": "Español",
      "zh": "中文",
      "fr": "Français",
      "it": "Italiano",
      "hi": "हिन्दी",
      "ta": "தமிழ்",
      "bn": "বাংলা",
      "ja": "日本語"
    },
    "chatTranslation": "Chat Translation",
    "autoTranslate": "Auto-translate messages",
    "autoTranslateDescription": "Automatically translate chat messages to your preferred language",
    "notifications": "Notifications",
    "pushNotifications": "Push Notifications",
    "playback": "Playback",
    "quality": "Quality",
    "subtitles": "Subtitles",
    "autoplay": "Autoplay",
    "appearance": "Appearance",
    "darkMode": "Dark Mode",
    "privacy": "Privacy",
    "privacyPolicy": "Privacy Policy",
    "termsOfService": "Terms of Service",
    "about": "About",
    "display": "Display",
    "homePageSections": "Home Page Sections",
    "configureSections": "Configure which sections appear on your home page",
    "visibleSections": "Visible Sections",
    "hiddenSections": "Hidden Sections",
    "dragToReorder": "Drag to reorder",
    "tapToHide": "Tap to hide",
    "tapToShow": "Tap to show",
    "resetToDefault": "Reset to Default",
    "resetConfirmMessage": "Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "Section hidden",
    "sectionShown": "Section shown",
    "replayTour": "Replay Feature Tour"
  },
  "help": {
    "subtitle": "How can we help you?",
    "email": "Email Support",
    "phone": "Phone Support",
    "chat": "Live Chat",
    "chatAvailable": "Available 24/7",
    "openTooltip": "Open help tooltip",
    "openHelp": "Open help menu",
    "howTo": "How to use",
    "relatedArticles": "Related articles",
    "stillNeedHelp": "Still need help?",
    "contactSupport": "Contact Support",
    "previous": "Previous",
    "next": "Next",
    "getStarted": "Get Started",
    "skipTutorial": "Skip tutorial",
    "actions": {
      "search": "Search Help",
      "docs": "Documentation",
      "faq": "FAQ",
      "support": "Contact Support",
      "tutorial": "View Tutorial"
    },
    "search": {
      "placeholder": "Search help...",
      "noResults": "No results found for \"{{query}}\"",
      "noResultsHint": "Try different keywords or browse categories",
      "recent": "Recent",
      "popular": "Popular"
    },
    "categories": {
      "getting-started": "Getting Started",
      "features": "Features",
      "judaism": "Judaism",
      "platform-guides": "Platform Guides",
      "account": "Account",
      "troubleshooting": "Troubleshooting",
      "parents": "For Parents",
      "admin": "Admin Guide",
      "developer": "Developer API"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "q1": "How do I change my subscription plan?",
      "a1": "Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "How do I download content for offline viewing?",
      "a2": "Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "Why isn't my video playing?",
      "a3": "Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "How do I cancel my subscription?",
      "a4": "You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "Welcome to Bayit+",
        "description": "Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "Live TV",
        "description": "Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "On-Demand Content",
        "description": "Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "Voice Control",
        "description": "Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "Family Profiles",
        "description": "Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "Voice Assistant",
    "typeCommand": "Type a command...",
    "controlExecuted": "Executed: {{action}}",
    "timerSet": "Timer set for {{amount}} {{unit}}",
    "chatPending": "Processing your message...",
    "suggestion": {
      "watchLive": "Watch Live TV",
      "search": "Search Content",
      "listenRadio": "Listen to Radio"
    },
    "error": {
      "micDenied": "Microphone access denied",
      "notSupported": "Voice commands not supported in this browser",
      "recognitionFailed": "Could not understand. Please try again."
    }
  },
  "errors": {
    "networkError": "Network Error",
    "loadingFailed": "Loading Failed",
    "tryAgain": "Try Again",
    "offline": {
      "title": "No Internet Connection",
      "message": "You are currently offline. Some features may not be available.",
      "ttsMessage": "No internet connection. You are now in offline mode."
    },
    "online": {
      "title": "Connection Restored",
      "message": "You are back online.",
      "ttsMessage": "Internet connection restored."
    },
    "api": {
      "badRequest": "Something went wrong. Please try again.",
      "unauthorized": "Please log in to continue.",
      "forbidden": "You do not have permission to access this content.",
      "notFound": "The content you are looking for is not available.",
      "rateLimit": "You are making too many requests. Please wait a moment.",
      "serverError": "Our servers are having issues. Please try again later.",
      "unknown": "Something went wrong. Please try again.",
      "networkTimeout": "Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "You are offline. Please check your internet connection.",
      "requestFailed": "Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "Microphone access is required for voice commands. Please enable it in Settings.",
      "recognitionFailed": "I didn't understand that. Please try again.",
      "commandFailed": "Voice command failed. Please try again."
    },
    "widget": {
      "loadFailed": "Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "OK",
      "retry": "Retry",
      "cancel": "Cancel"
    },
    "title": "Error",
    "networkUnavailable": "Network unavailable",
    "no_audio_url": "No audio URL available",
    "connection_failed": "Connection Failed",
    "quota_exceeded": "Quota Exceeded",
    "server_error": "Server Error"
  },
  "player": {
    "loading": "Loading...",
    "retry": "Try Again",
    "error": "Error playing video",
    "back": "← Back",
    "liveBadge": "LIVE",
    "noStream": "Stream not available",
    "loadError": "Failed to load stream",
    "settings": "Settings",
    "subtitles": "Subtitles",
    "playbackSpeed": "Playback Speed",
    "quality": "Quality",
    "auto": "Auto",
    "previousChapter": "Previous chapter",
    "nextChapter": "Next chapter",
    "skipBackward": "Skip backward 30 seconds",
    "skipForward": "Skip forward 30 seconds",
    "restart": "Restart from beginning",
    "subtitlesOff": "Off",
    "speed": "Speed",
    "subscription": {
      "requiredTitle": "Subscription Required",
      "requiredMessage": "requires a paid subscription",
      "upgradeInfo": "Upgrade your subscription to access premium content",
      "upgrade": "Upgrade Now"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "Dubbing",
      "featuresTitle": "AI Features",
      "languagePrimary": "Primary",
      "languageSecondary": "Secondary (Optional)",
      "languageTitle": "AI Language",
      "liveTranslate": "Live Translate",
      "selectLanguage": "Select Language",
      "split": "Split",
      "togglePanel": "Toggle AI Panel",
      "translate": "Translate",
      "trivia": "Trivia",
      "triviaToggle": "Trivia"
    },
    "catchup": {
      "description": "Missed the beginning? Get an AI-powered summary of what happened so far.",
      "generateSummary": "Generate Summary",
      "summaryTitle": "Summary",
      "title": "Catch Up",
      "keyPoints": "Key Points",
      "transcript": "Transcript"
    },
    "chat": {
      "title": "Live Chat",
      "messagePlaceholder": "Type a message..."
    },
    "companion": {
      "noContext": "No cultural context available for this content yet.",
      "quizComplete": "Quiz Complete",
      "quizRetry": "Retry",
      "quizStart": "Start Quiz",
      "quizTitle": "Ready to test your knowledge?",
      "quizTryAgain": "Try Again",
      "tabContext": "Context",
      "tabQuiz": "Quiz",
      "tabVocabulary": "Vocabulary",
      "tapWords": "Tap words in subtitles to add them here",
      "title": "AI Companion",
      "loadError": "Failed to load AI learning data"
    },
    "controls": {
      "audioTrack": "Audio Track",
      "continueWatching": "Continue Watching",
      "dismiss": "Dismiss",
      "goBack": "Go Back",
      "navigateBack": "Navigate back",
      "on": "ON",
      "pause": "Pause",
      "play": "Play",
      "preview": "Preview",
      "selected": "Selected",
      "send": "Send",
      "skip": "Skip",
      "close": "Close",
      "exitFullscreen": "Exit Fullscreen",
      "fullscreen": "Fullscreen",
      "restart": "Restart",
      "skipBackward": "Skip Backward",
      "skipForward": "Skip Forward",
      "volume": "Volume"
    },
    "dubbing": {
      "notNow": "Not Now",
      "premiumMessage": "Live dubbing requires a Premium or Beta 500 subscription",
      "premiumTitle": "Premium Feature",
      "upgrade": "Upgrade",
      "voiceTitle": "Dubbing Voice",
      "settings_title": "Live Dubbing Settings",
      "target_language": "Target Language"
    },
    "errors": {
      "streamLimitMessage": "You have reached the maximum of {{maxStreams}} concurrent streams. Please stop another stream or upgrade your plan.",
      "streamLimitTitle": "Stream Limit Reached",
      "upgradePlan": "Upgrade Plan"
    },
    "audio_description": "Audio Description",
    "dismiss": "Dismiss",
    "scene_search": "Scene Search",
    "search_placeholder": "Search for a scene...",
    "language_ratio": "Language Learning Ratio",
    "go_back": "Go Back",
    "sleepTimer": {
      "title": "Sleep Timer",
      "subtitle": "Auto-pause playback after a set time",
      "minutes": "{{count}} min",
      "customPlaceholder": "Custom minutes",
      "set": "Set Timer",
      "remaining": "Sleep in {{time}}",
      "extend": "+15 min",
      "cancel": "Cancel Timer",
      "off": "Off",
      "setTimer": "Set Sleep Timer"
    },
    "openSubs": {
      "title": "Search Subtitles",
      "searchPlaceholder": "Search by title...",
      "search": "Search",
      "searchFailed": "Search failed. Try again.",
      "downloads": "{{count}} downloads",
      "noResults": "No subtitles found"
    },
    "dialogue": {
      "cancel": "Cancel",
      "close": "Close",
      "placeholder": "Type your message...",
      "selectCharacter": "Select Character",
      "send": "Send",
      "sharedSession": "Shared Session",
      "waitingForTurn": "Waiting for your turn...",
      "yourAvatar": "Your Avatar"
    },
    "interaction": {
      "next": "Next",
      "previous": "Previous",
      "skip": "Skip",
      "start": "Start Interaction",
      "window": "Interaction window: {{duration}} seconds"
    },
    "pauseAsk": {
      "askAgain": "Ask Again",
      "placeholder": "Ask about this scene...",
      "resume": "Resume",
      "resumeMovie": "Resume Movie",
      "selectCharacter": "Select Character",
      "title": "Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "Literal",
      "meaning": "Meaning",
      "origin": "Origin",
      "funFact": "Fun Fact",
      "usage": "Usage: {{level}}"
    },
    "translation": {
      "example": "Example:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "Subtitle Mode",
      "modes": {
        "regular": {
          "name": "Regular",
          "description": "Standard Hebrew subtitles without vowel marks"
        },
        "nikud": {
          "name": "Nikud",
          "description": "Hebrew with vowel marks for easier reading"
        },
        "shoresh": {
          "name": "Shoresh",
          "description": "Root-based learning with word origins highlighted"
        },
        "engrew": {
          "name": "Engrew",
          "description": "English transliteration with Hebrew context"
        },
        "heblish": {
          "name": "Heblish",
          "description": "English with Hebrew terms and cultural context"
        },
        "grammarFlip": {
          "name": "Grammar Flip",
          "description": "Hebrew sentence structure with English words"
        },
        "slangSynthesis": {
          "name": "Slang Synthesis",
          "description": "Cultural slang and idioms explained"
        }
      }
    }
  },
  "empty": {
    "noContent": "No content available",
    "tryAnotherCategory": "Try selecting another category",
    "noPodcasts": "No podcasts available",
    "tryLater": "Try again later",
    "noResults": "No results found"
  },
  "content": {
    "play": "Play",
    "addToList": "Add to List",
    "inList": "In List",
    "details": "Details",
    "synopsis": "Synopsis",
    "genre": "Genre",
    "genres": "Genres",
    "runtime": "Runtime",
    "released": "Released",
    "director": "Director",
    "starring": "Starring",
    "cast": "Cast",
    "season": "Season",
    "seasons": "Seasons",
    "episode": "Episode",
    "episodes": "Episodes",
    "ep": "Ep",
    "selectSeason": "Select Season",
    "noEpisodes": "No episodes available",
    "noEpisodesAvailable": "No episodes available to play",
    "loadingSeries": "Loading series information...",
    "votes": "votes",
    "rating": "Rating",
    "imdbRating": "IMDB Rating",
    "preview": "Preview",
    "previewPlaying": "Preview playing",
    "trailerPlaying": "Trailer playing",
    "watchTrailer": "Watch Trailer",
    "youMayAlsoLike": "You May Also Like",
    "relatedContent": "Related Content",
    "notFound": "Content not found",
    "availableSubtitles": "Available Subtitles",
    "subtitleSelected": "Selected: {{language}}"
  },
  "breadcrumbs": {
    "series": "Series",
    "movie": "Movie",
    "watching": "Watching",
    "channel": "Channel",
    "station": "Station",
    "podcast": "Podcast",
    "watchlist": "Watchlist",
    "downloads": "Downloads"
  },
  "favorites": {
    "title": "Favorites",
    "items": "items",
    "empty": "No favorites yet",
    "emptyHint": "Add items to your favorites"
  },
  "downloads": {
    "title": "Downloads",
    "items": "items",
    "storage": "Storage",
    "empty": "No downloads",
    "emptyHint": "Download content for offline viewing",
    "paused": "Paused"
  },
  "watchlist": {
    "filters": {
      "all": "All",
      "continue": "Continue Watching",
      "movies": "Movies",
      "series": "Series",
      "kids": "Kids",
      "judaism": "Judaism",
      "podcasts": "Podcasts",
      "radio": "Radio"
    },
    "title": "Watchlist",
    "items": "items",
    "watched": "watched",
    "empty": "Your watchlist is empty",
    "emptyHint": "Start watching and items will appear here"
  },
  "widgets": {
    "empty": "No widgets yet",
    "emptyHint": "Your widgets will appear here",
    "emptyPersonal": "No personal widgets yet",
    "emptyPersonalHint": "Create your first personal widget or add system widgets above",
    "itemsTotal": "total widgets",
    "systemWidgets": "System Widgets",
    "systemWidgetsHint": "Browse and add widgets to your collection",
    "myWidgets": "My Personal Widgets",
    "myWidgetsHint": "Widgets you have created",
    "personalWidgets": "My Widgets",
    "noSystemWidgets": "No system widgets available",
    "added": "Added",
    "add": "Add",
    "remove": "Remove",
    "show": "Show",
    "hidden": "Hidden",
    "addToCollection": "Add to My Widgets",
    "removeFromCollection": "Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "Live Channel",
      "iframe": "Web Content",
      "podcast": "Podcast",
      "radio": "Radio",
      "vod": "Video",
      "custom": "Custom",
      "widget": "Widget"
    },
    "form": {
      "title": "Create Widget",
      "basicInfo": "Basic Information",
      "titlePlaceholder": "Widget Title",
      "titleRequired": "Widget Title is required",
      "descriptionPlaceholder": "Description (optional)",
      "iconPlaceholder": "Icon emoji (e.g., 📺)",
      "content": "Content",
      "fromLibrary": "From Library",
      "iframe": "iFrame",
      "selectContent": "Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "iFrame URL",
      "iframeUrlRequired": "iFrame URL is required",
      "iframeTitle": "iFrame Title",
      "positionSize": "Position & Size",
      "behavior": "Behavior",
      "mutedByDefault": "Muted by Default",
      "closable": "Closable",
      "draggable": "Draggable",
      "widgetOrder": "Widget Order",
      "orderPlaceholder": "Order (0 = first)",
      "saveWidget": "Save Widget",
      "saving": "Saving...",
      "cancel": "Cancel",
      "change": "Change"
    }
  },
  "trending": {
    "title": "What's Trending in Israel",
    "noTopics": "No trending topics available",
    "topStory": "TOP STORY",
    "sources": "Sources",
    "categories": {
      "security": "Security",
      "politics": "Politics",
      "tech": "Tech",
      "culture": "Culture",
      "sports": "Sports",
      "economy": "Economy",
      "entertainment": "Entertainment",
      "weather": "Weather",
      "health": "Health",
      "general": "General"
    }
  },
  "cultures": {
    "title": "Select Your Culture",
    "select": "Select Culture",
    "selectCulture": "Choose Your Culture",
    "selectCultureDescription": "Select your cultural community to personalize your experience",
    "changeCulture": "Change Culture",
    "israeli": {
      "name": "Israeli",
      "description": "Israeli expat community content"
    },
    "chinese": {
      "name": "Chinese",
      "description": "Chinese community content"
    },
    "japanese": {
      "name": "Japanese",
      "description": "Japanese community content"
    },
    "korean": {
      "name": "Korean",
      "description": "Korean community content"
    },
    "indian": {
      "name": "Indian",
      "description": "Indian community content"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "What's Hot in {{location}}",
    "noTopics": "No trending topics available",
    "sources": "Sources",
    "categories": {
      "security": "Security",
      "politics": "Politics",
      "tech": "Tech",
      "technology": "Technology",
      "culture": "Culture",
      "sports": "Sports",
      "economy": "Economy",
      "finance": "Finance",
      "entertainment": "Entertainment",
      "weather": "Weather",
      "health": "Health",
      "food": "Food",
      "fashion": "Fashion",
      "travel": "Travel",
      "history": "History",
      "expat": "Expat Life",
      "general": "General"
    }
  },
  "cultureClock": {
    "timeIn": "Time in {{location}}",
    "shabbat": "Shabbat",
    "weekend": "Weekend"
  },
  "cultureCities": {
    "connectionTo": "{{city}} Connection",
    "explore": "Explore {{city}}",
    "noContent": "No content available for this city",
    "categories": {
      "all": "All",
      "history": "History",
      "culture": "Culture",
      "finance": "Finance",
      "tech": "Tech",
      "food": "Food",
      "expat": "Expat Life",
      "news": "News",
      "entertainment": "Entertainment"
    }
  },
  "clock": {
    "israel": "Israel",
    "local": "Local",
    "shabbatShalom": "Shabbat Shalom!",
    "erevShabbat": "Erev Shabbat",
    "candleLighting": "Candle Lighting",
    "parasha": "Parasha"
  },
  "ritual": {
    "title": "Morning Ritual",
    "greeting": "Good Morning!",
    "israelUpdate": "It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "We recommend starting with morning news then switching to radio",
    "preparingRitual": "Preparing your morning ritual...",
    "israelTime": "Israel Time",
    "day": "Day",
    "letsStart": "Let's Start",
    "skipToday": "Skip for Today",
    "finish": "Finish",
    "noContentNow": "No content available right now",
    "typeLive": "Live",
    "typeRadio": "Radio",
    "typeVideo": "Video"
  },
  "watchParty": {
    "title": "Watch Party",
    "create": "Create Party",
    "join": "Join Party",
    "active": "Party Active",
    "createTitle": "Create Watch Party",
    "joinTitle": "Join Party",
    "enterCode": "Enter Room Code",
    "roomCode": "Room Code",
    "copyCode": "Copy Code",
    "codeCopied": "Code Copied!",
    "participants": "Participants",
    "host": "Host",
    "you": "You",
    "leave": "Leave Party",
    "end": "End Party",
    "chat": "Chat",
    "sendMessage": "Send Message",
    "typeMessage": "Type a message...",
    "synced": "Synced",
    "syncing": "Syncing...",
    "hostPaused": "Host Paused",
    "userJoined": "{{name}} joined",
    "userLeft": "{{name}} left",
    "partyEnded": "The party has ended",
    "connecting": "Connecting...",
    "options": {
      "chatEnabled": "Enable Chat",
      "syncPlayback": "Sync Playback"
    },
    "errors": {
      "invalidCode": "Invalid code",
      "partyFull": "Party is full",
      "partyEnded": "Party has ended",
      "connectionError": "Connection error",
      "createFailed": "Failed to create party",
      "joinFailed": "Failed to join party"
    },
    "audio": {
      "mute": "Mute",
      "unmute": "Unmute",
      "speaking": "Speaking",
      "connecting": "Connecting to audio...",
      "noAudio": "Audio not available"
    },
    "textOnlyMode": "Text Chat Only",
    "endParty": "End Party"
  },
  "footer": {
    "brandDescription": "Your home in the USA. TV broadcasts, VOD, radio and podcasts in Hebrew.",
    "browse": "Browse",
    "account": "Account",
    "support": "Support",
    "legal": "Legal",
    "location": "New York, USA",
    "links": {
      "home": "Home",
      "liveTV": "Live TV",
      "vod": "Movies & Series",
      "radio": "Radio",
      "podcasts": "Podcasts",
      "judaism": "Judaism",
      "profile": "My Profile",
      "favorites": "Favorites",
      "watchlist": "Watchlist",
      "subscribe": "Subscribe",
      "downloads": "Downloads",
      "help": "Help Center",
      "faq": "FAQ",
      "contact": "Contact Us",
      "feedback": "Feedback",
      "terms": "Terms of Service",
      "privacy": "Privacy Policy",
      "cookies": "Cookie Policy",
      "licenses": "Licenses"
    },
    "newsletter": {
      "title": "Stay Updated",
      "description": "Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "Enter your email",
      "success": "Thanks for subscribing!"
    },
    "apps": {
      "title": "Get the App",
      "downloadOn": "Download on",
      "getItOn": "Get it on",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "social": {
      "facebook": "Facebook",
      "twitter": "Twitter",
      "instagram": "Instagram",
      "youtube": "YouTube"
    },
    "copyright": "© {{year}} Bayit+. All rights reserved.",
    "poweredBy": "Powered by",
    "sitemap": "Sitemap",
    "accessibility": "Accessibility",
    "navigation": "Navigation",
    "liveTV": "Live TV",
    "moviesAndSeries": "Movies & Series",
    "radioStations": "Radio Stations",
    "myProfile": "My Profile",
    "subscriptions": "Subscriptions",
    "helpAndSupport": "Help & Support",
    "termsOfUse": "Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "contactUs": "Contact Us"
  },
  "chapters": {
    "title": "Chapters",
    "noChapters": "No chapters available",
    "generating": "Generating chapters...",
    "jumpTo": "Jump to",
    "current": "Now",
    "categories": {
      "intro": "Introduction",
      "news": "News",
      "security": "Security",
      "politics": "Politics",
      "economy": "Economy",
      "sports": "Sports",
      "weather": "Weather",
      "culture": "Culture",
      "conclusion": "Conclusion"
    },
    "chapterLabel": "Chapter {{number}}",
    "chapter_number": "Chapter {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ Admin",
      "subtitle": "System Management"
    },
    "backToApp": "Back to App",
    "refunds": {
      "subtitle": "Manage refund requests",
      "approveModal": {
        "title": "Confirm Approval",
        "message": "Approve refund of {{amount}}?"
      },
      "confirmApprove": "Approve refund of {{amount}}?",
      "confirmDelete": "Delete refund request?",
      "rejectModal": {
        "title": "Reject Refund Request",
        "message": "Rejecting refund of {{amount}}",
        "reasonLabel": "Rejection Reason",
        "reasonPlaceholder": "Please enter rejection reason...",
        "submitButton": "Reject Request"
      },
      "status": {
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "columns": {
        "id": "ID",
        "user": "User",
        "amount": "Amount",
        "reason": "Reason",
        "status": "Status",
        "requestDate": "Request Date"
      },
      "stats": {
        "pendingTitle": "Pending Approval",
        "approvedTitle": "Approved",
        "rejectedTitle": "Rejected",
        "totalRefunded": "Total Refunded"
      },
      "emptyMessage": "No refund requests found",
      "errors": {
        "rejectReasonRequired": "Please enter rejection reason"
      },
      "title": "Refunds"
    },
    "plans": {
      "title": "Plan Management",
      "subtitle": "Configure and manage subscription plans",
      "createButton": "New Plan",
      "inactive": "Inactive",
      "subscribersLabel": "Subscribers:",
      "intervals": {
        "monthly": "month",
        "yearly": "year"
      },
      "trialDays": "{{days}} day trial",
      "modal": {
        "editTitle": "Edit Plan",
        "createTitle": "New Plan"
      },
      "form": {
        "nameEn": "Name (English)",
        "nameHe": "Name (Hebrew)",
        "price": "Price ($)",
        "interval": "Billing Period",
        "trialDays": "Trial Days",
        "features": "Features (one per line)",
        "active": "Active Plan"
      },
      "errors": {
        "requiredFields": "Name and price are required"
      },
      "confirmDelete": "Delete plan \"{{name}}\"?"
    },
    "emailCampaigns": {
      "subtitle": "Create and manage email campaigns",
      "createButton": "New Campaign",
      "searchPlaceholder": "Search campaign...",
      "emptyMessage": "No campaigns found",
      "status": {
        "draft": "Draft",
        "active": "Active",
        "scheduled": "Scheduled",
        "completed": "Completed"
      },
      "columns": {
        "name": "Campaign Name",
        "status": "Status",
        "sent": "Sent",
        "opened": "Opened",
        "clicked": "Clicked",
        "created": "Created",
        "actions": "Actions"
      },
      "editModal": {
        "title": "Edit Campaign"
      },
      "sendTestEmail": "Send Test",
      "confirmSend": "Send campaign \"{{name}}\"?",
      "confirmDelete": "Delete campaign \"{{name}}\"?",
      "testEmailSent": "Test email sent!",
      "createModal": {
        "title": "New Email Campaign"
      },
      "form": {
        "name": "Campaign Name",
        "namePlaceholder": "e.g., Year End Sale",
        "subject": "Email Subject",
        "subjectPlaceholder": "Subject shown to recipients",
        "body": "Content",
        "bodyPlaceholder": "Email content...",
        "submitButton": "Create Campaign",
        "requiredFields": "Name and subject are required"
      },
      "testModal": {
        "title": "Send Test Email",
        "emailLabel": "Email Address",
        "emailPlaceholder": "test@example.com",
        "submitButton": "Send Test"
      },
      "errors": {
        "requiredFields": "Name and subject are required"
      }
    },
    "dashboard": {
      "subtitle": "System Overview",
      "refresh": "Refresh",
      "timeAgo": {
        "minutes": "{{count}} minutes ago",
        "hours": "{{count}} hours ago"
      },
      "title": "Dashboard",
      "users": "Users",
      "revenue": "Revenue",
      "subscriptions": "Subscriptions",
      "recentActivity": "Recent Activity",
      "quickActions": "Quick Actions"
    },
    "common": {
      "all": "All",
      "cancel": "Cancel",
      "save": "Save",
      "active": "Active",
      "back": "Back",
      "filterAction": "Action",
      "filterResource": "Resource",
      "filterUser": "User",
      "filterDateRange": "Date range"
    },
    "stats": {
      "totalUsers": "Total Users",
      "activeUsers": "Active Users",
      "newToday": "New Today",
      "newThisWeek": "New This Week",
      "totalRevenue": "Total Revenue",
      "revenueToday": "Revenue Today",
      "revenueMonth": "Revenue This Month",
      "arpu": "ARPU",
      "activeSubscriptions": "Active Subscriptions",
      "churnRate": "Churn Rate"
    },
    "actions": {
      "new": "New",
      "addUser": "Add User",
      "newCampaign": "New Campaign",
      "sendEmail": "Send Email",
      "viewReports": "View Reports"
    },
    "auditActions": {
      "user_created": "User Created",
      "user_updated": "User Updated",
      "user_deleted": "User Deleted",
      "user_role_changed": "User Role Changed",
      "campaign_created": "Campaign Created",
      "campaign_updated": "Campaign Updated",
      "campaign_deleted": "Campaign Deleted",
      "campaign_activated": "Campaign Activated",
      "subscription_created": "Subscription Created",
      "subscription_updated": "Subscription Updated",
      "subscription_canceled": "Subscription Canceled",
      "subscription_deleted": "Subscription Deleted",
      "refund_processed": "Refund Processed",
      "payment_received": "Payment Received",
      "settings_updated": "Settings Updated",
      "login": "Login",
      "logout": "Logout",
      "content_created": "Content Created",
      "content_updated": "Content Updated",
      "content_deleted": "Content Deleted",
      "content_published": "Content Published",
      "content_unpublished": "Content Unpublished",
      "category_created": "Category Created",
      "category_updated": "Category Updated",
      "category_deleted": "Category Deleted",
      "live_channel_created": "Live Channel Created",
      "live_channel_updated": "Live Channel Updated",
      "live_channel_deleted": "Live Channel Deleted",
      "radio_station_created": "Radio Station Created",
      "radio_station_updated": "Radio Station Updated",
      "radio_station_deleted": "Radio Station Deleted",
      "podcast_created": "Podcast Created",
      "podcast_updated": "Podcast Updated",
      "podcast_deleted": "Podcast Deleted",
      "podcast_episode_created": "Podcast Episode Created",
      "podcast_episode_updated": "Podcast Episode Updated",
      "podcast_episode_deleted": "Podcast Episode Deleted",
      "content_imported": "Content Imported",
      "widget_created": "Widget Created",
      "widget_updated": "Widget Updated",
      "widget_deleted": "Widget Deleted",
      "widget_published": "Widget Published",
      "widget_unpublished": "Widget Unpublished"
    },
    "placeholder": {
      "userId": "Enter user ID",
      "discount": "0"
    },
    "titles": {
      "users": "Users",
      "transactions": "Transactions",
      "subscriptions": "Subscriptions",
      "refunds": "Refunds",
      "plans": "Plans",
      "campaigns": "Campaigns",
      "auditLogs": "Audit Logs",
      "pushNotifications": "Push Notifications",
      "billing": "Billing",
      "marketing": "Marketing",
      "content": "Content Library",
      "categories": "Categories",
      "liveChannels": "Live Channels",
      "radioStations": "Radio Stations",
      "podcasts": "Podcasts",
      "settings": "Settings"
    },
    "nav": {
      "dashboard": "Dashboard",
      "users": "Users",
      "campaigns": "Campaigns",
      "billing": "Billing",
      "billingOverview": "Overview",
      "transactions": "Transactions",
      "refunds": "Refunds",
      "subscriptions": "Subscriptions",
      "subscriptionsList": "Subscribers",
      "plans": "Plans",
      "marketing": "Marketing",
      "marketingDashboard": "Overview",
      "emailCampaigns": "Email Campaigns",
      "pushNotifications": "Push Notifications",
      "content": "Content",
      "contentLibrary": "Content Library",
      "categories": "Categories",
      "liveChannels": "Live Channels",
      "radioStations": "Radio Stations",
      "podcasts": "Podcasts",
      "widgets": "Widgets",
      "recordings": "Recordings",
      "uploads": "Uploads",
      "settings": "Settings",
      "auditLogs": "Audit Logs",
      "librarian": "Librarian Agent",
      "featured": "Featured"
    },
    "featured": {
      "title": "Featured Content",
      "subtitle": "Manage featured content for homepage carousels",
      "empty": "No featured content",
      "emptyHint": "Featured items will appear in their respective carousels on the homepage",
      "count": "{{count}} items",
      "confirmUnfeature": "Remove from featured?",
      "remove": "Remove",
      "unsavedChanges": "You have unsaved changes",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} item",
        "itemCount_plural": "{{count}} items",
        "empty": "No featured items",
        "emptyHint": "Featured items will appear in the {{name}} carousel on the homepage"
      },
      "saveButton": "Save {{count}} Section",
      "saveButton_plural": "Save {{count}} Sections",
      "saving": "Saving...",
      "saveSuccess": "Featured content updated successfully",
      "saveFailed": "Failed to save featured content",
      "removeConfirm": "Remove from {{section}}?",
      "removeSuccess": "Removed from {{section}}"
    },
    "recordings": {
      "title": "Recordings Management",
      "subtitle": "Manage user recordings across the platform",
      "totalRecordings": "Total Recordings",
      "totalStorage": "Total Storage",
      "totalUsers": "Users with Recordings",
      "activeSessions": "Active Sessions",
      "searchPlaceholder": "Search by title, user, or channel...",
      "user": "User",
      "confirmDelete": "Delete recording '{{title}}'? This action cannot be undone.",
      "deleteRecording": "Delete Recording",
      "deleteSuccess": "Recording deleted successfully",
      "deleteFailed": "Failed to delete recording",
      "loadFailed": "Failed to load recordings",
      "noRecordings": "No Recordings Found",
      "noRecordingsHint": "No user recordings in the system yet."
    },
    "uploads": {
      "title": "Uploads Management",
      "subtitle": "Manage content uploads and automated folder monitoring",
      "activeUploads": "Active Uploads",
      "noActiveUploads": "No active uploads",
      "queuedUploads": "Queued Uploads",
      "queued": "Queued",
      "andMore": "And {{count}} more",
      "monitoredFolders": "Monitored Folders",
      "noMonitoredFolders": "No monitored folders configured",
      "configureFoldersHelp": "Click 'Add Folder' to configure monitored folders for automatic uploads",
      "addFolder": "Add Folder",
      "editFolder": "Edit Folder",
      "deleteFolder": "Delete Folder",
      "confirmDelete": "Delete this folder?",
      "triggerUpload": "Trigger Upload",
      "triggerUploadSuccess": "Found {{files_found}} new files to upload",
      "triggerUploadFailed": "Failed to trigger upload scan",
      "noFilesFound": "No new files found in monitored folders",
      "sessionIssue": "Session Issue",
      "sessionIssueHelp": "Your session may have expired. Please refresh the page to restore connection.",
      "sessionExpired": "Session expired. Please refresh the page or log in again.",
      "unauthorized": "Session invalid. Please refresh the page.",
      "endpointNotFound": "Upload service not available. Check server configuration.",
      "timeout": "Upload scan timed out. Try again or check monitored folders.",
      "wsDisconnected": "Real-time Updates Disabled",
      "wsDisconnectedHelp": "WebSocket connection failed. Queue status may be outdated. Page will auto-retry.",
      "wsReconnecting": "Reconnecting to real-time updates...",
      "uploadAlreadyRunning": "Upload scan already in progress. Please wait for current uploads to complete.",
      "uploadsActiveNotice": "Uploads in progress ({{processing}} active, {{queued}} queued). New scan disabled until current batch completes.",
      "clearQueue": "Clear Queue",
      "clearQueueConfirmTitle": "Clear Upload Queue?",
      "clearQueueConfirmMessage": "This will cancel {{count}} active job(s). This action cannot be undone.",
      "clearQueueSuccess": "Queue cleared successfully",
      "clearQueueFailed": "Failed to clear queue",
      "cancelUpload": "Cancel",
      "cancelUploadConfirm": "Cancel this upload?",
      "cancelUploadSuccess": "Upload cancelled",
      "cancelUploadFailed": "Failed to cancel upload",
      "resetCache": "Reset Cache",
      "cacheResetSuccess": "Cache cleared: {{count}} files will be rescanned on next scan",
      "cacheResetFailed": "Failed to reset cache",
      "contentTypeFilters": "Content Type Filters",
      "contentTypeFiltersHelp": "Optional - Leave all unchecked to process all content types",
      "moviesOnly": "Movies Only",
      "seriesOnly": "Series Only",
      "audiobooksOnly": "Audiobooks Only",
      "type": "Type",
      "lastScan": "Last scan",
      "systemInfo": "Upload System Information",
      "systemInfoText": "Automatically extracts subtitles from local video files during upload for faster processing",
      "languagesInfo": "Supported subtitle languages: English (en), Hebrew (he), Spanish (es)",
      "queueStatus": "Upload Queue",
      "totalJobs": "Total",
      "processing": "Active",
      "completed": "Done",
      "skipped": "Skipped",
      "failed": "Failed",
      "queuePaused": "Queue Paused",
      "resumeQueue": "Resume",
      "activeUpload": "Active Upload",
      "queuedItems": "Queued",
      "noQueuedItems": "No items in queue",
      "addedAt": "Added",
      "recentCompleted": "Recently Completed",
      "stages": {
        "browserUpload": "Uploading to server",
        "hashCalculation": "Calculating hash",
        "duplicateCheck": "Checking for duplicates",
        "metadataExtraction": "Extracting metadata",
        "gcsUpload": "Uploading to cloud",
        "databaseInsert": "Saving to database",
        "imdbLookup": "Fetching IMDB info",
        "subtitleExtraction": "Extracting subtitles",
        "completed": "Completed",
        "failed": "Failed",
        "skipped": "Skipped"
      },
      "form": {
        "name": "Folder Name",
        "namePlaceholder": "My Movies Folder",
        "path": "Folder Path",
        "pathHelp": "Enter the server path to the folder (e.g., /Volumes/USB Drive/Movies)",
        "contentType": "Content Type",
        "enabled": "Enabled",
        "autoUpload": "Auto Upload"
      },
      "contentTypes": {
        "movie": "Movies",
        "series": "Series",
        "audiobook": "Audiobooks"
      },
      "errors": {
        "pathRequired": "Folder path is required"
      },
      "manualUpload": {
        "title": "Manual Upload",
        "subtitle": "Drag and drop files or select a folder",
        "dropHere": "Drop files here or click to browse",
        "dropHereActive": "Drop files to add them",
        "selectFolder": "Select Folder",
        "supportedFormats": "Supports video files (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "Selected Files",
        "noFilesSelected": "No files selected",
        "clearAll": "Clear All",
        "uploadSelected": "Upload Selected",
        "selectContentType": "Select content type for upload",
        "uploadingFiles": "Adding {{count}} file(s) to queue...",
        "uploadSuccess": "Successfully added {{count}} file(s) to queue",
        "uploadFailed": "Failed to add files to queue",
        "fileSize": "Size",
        "removeFile": "Remove",
        "invalidFileType": "Invalid file type. Only video files are supported.",
        "filesCount": "{{count}} file(s) selected",
        "pendingRestore": "{{count}} file(s) pending from previous session",
        "pendingRestoreHint": "Drop or select the same files to restore your upload queue"
      }
    },
    "librarian": {
      "title": "Librarian Agent",
      "subtitle": "Autonomous AI-powered content library management",
      "loading": "Loading Librarian Agent...",
      "loadingConfig": "Loading configuration...",
      "refresh": "Refresh",
      "errors": {
        "configError": "Configuration Error",
        "configNotLoaded": "Configuration not loaded",
        "failedToLoad": "Failed to load librarian data",
        "failedToLoadConfig": "Failed to load librarian configuration",
        "failedToTrigger": "Failed to trigger audit. Please try again.",
        "failedToLoadDetails": "Failed to load report details.",
        "failedToRollback": "Failed to rollback action.",
        "failedToClearReports": "Failed to clear audit reports. Please try again.",
        "failedToPause": "Failed to pause audit",
        "failedToResume": "Failed to resume audit",
        "failedToCancel": "Failed to cancel audit",
        "failedToInterject": "Failed to send message to AI agent",
        "auditAlreadyRunning": "An audit is already running. Please wait for it to complete or cancel it before starting a new one.",
        "budgetExceeded": "Monthly budget limit exceeded. Cannot run audit.",
        "contactAdmin": "The Librarian page cannot load without proper configuration.\nPlease contact your administrator."
      },
      "stats": {
        "systemHealth": "System Health",
        "totalAudits": "Total Audits (30d)",
        "last30Days": "Last 30 days",
        "issuesFixed": "Issues Fixed",
        "lastAudit": "Last Audit",
        "never": "Never",
        "unknown": "unknown"
      },
      "health": {
        "excellent": "excellent",
        "good": "good",
        "fair": "fair",
        "poor": "poor",
        "unknown": "unknown"
      },
      "quickActions": {
        "title": "Run Configuration",
        "subtitle": "Configure and trigger audits",
        "auditMode": "Audit Mode",
        "auditModeHelp": "Choose what to check",
        "dryRun": "Preview Mode",
        "dryRunHelp": "Show what would change without making changes",
        "scopeFilters": "Audit Capabilities",
        "scopeFiltersHelp": "Select capabilities to enable (multiple can be combined)",
        "last24Hours": "Recent Content Only",
        "last24HoursHelp": "Limit audit to content added in the last 24 hours",
        "cybTitlesOnly": "Clean Dirty Titles",
        "cybTitlesOnlyHelp": "Remove file extensions, quality markers, and release tags from titles",
        "tmdbPostersOnly": "TMDB Posters & Metadata",
        "tmdbPostersOnlyHelp": "Fetch missing posters, descriptions, and metadata from TMDB",
        "openSubtitlesEnabled": "Acquire Subtitles",
        "openSubtitlesEnabledHelp": "Download missing subtitles from OpenSubtitles (HE/EN/ES)",
        "classifyOnly": "Verify Classification",
        "classifyOnlyHelp": "Check and fix movie vs series classification errors",
        "purgeDuplicates": "Remove Duplicates",
        "purgeDuplicatesHelp": "Find and remove duplicate content items",
        "auditType": "Audit Type",
        "auditTypeHelp": "Choose between rule-based or AI-powered audit",
        "dailyAudit": "Daily Audit",
        "dailyBadge": "Rule-Based • Fast • Free",
        "dailyDescription": "Runs predefined checks on content modified in the last 7 days. Fast and predictable, no AI costs.",
        "aiAgentAudit": "AI Agent Audit",
        "aiAgentBadge": "AI-Powered • Intelligent • Uses Budget",
        "aiAgentDescription": "Autonomous AI agent (Claude) makes intelligent decisions about what to check and fix. More comprehensive but uses API budget.",
        "triggerDaily": "Run Daily Audit",
        "triggerAI": "Run AI Agent Audit",
        "auditRunningNotice": "An audit is currently running. Buttons will be enabled when it completes.",
        "budgetLabel": "AI Agent Budget Limit: ${{budget}}",
        "budgetPerAudit": "Budget per Audit",
        "monthlyBudgetUsed": "Budget Used (30d)",
        "monthlyBudgetLimit": "/ ${{limit}} monthly",
        "budgetWarning": "Running this audit would exceed monthly budget limit",
        "aiAuditSuccess": "AI Agent audit triggered successfully. {{dryRun}}",
        "dailyAuditSuccess": "Daily audit triggered successfully. {{dryRun}}",
        "dryRunMode": "(Dry run mode)",
        "rollbackSuccess": "Action rolled back successfully."
      },
      "voice": {
        "title": "Voice Control",
        "description": "Use your voice to give commands to the librarian. Just press the button and speak naturally.",
        "pressToSpeak": "Press to Speak",
        "listening": "Listening...",
        "transcript": "Transcript",
        "processing": "Processing your command...",
        "speaking": "Librarian is responding...",
        "examples": "Example Commands",
        "example1": "Check for missing posters in the last 24 hours",
        "example2": "Fix metadata for CYB titles",
        "example3": "Scan for broken streaming URLs",
        "example4": "Extract subtitles from movies",
        "notSupported": "Voice recognition is not supported in your browser. Please use Chrome, Edge, or Safari.",
        "notAvailable": "Voice control is not available",
        "noSpeech": "No speech detected. Please try again.",
        "noMicrophone": "No microphone detected. Please check your device.",
        "microphoneBlocked": "Microphone access was blocked. Please enable it in your browser settings.",
        "error": "Speech recognition error: {{error}}",
        "startFailed": "Failed to start voice recognition. Please try again.",
        "commandFailed": "Failed to execute command. Please try again."
      },
      "schedules": {
        "title": "Scheduled Audits",
        "subtitle": "Configure daily and weekly audit schedules",
        "dailyTitle": "Daily Audit",
        "weeklyTitle": "Weekly AI Audit",
        "schedule": "Schedule",
        "time": "Time",
        "mode": "Mode",
        "cost": "Est. Cost",
        "status": "Status",
        "description": "Description",
        "viewInConsole": "View in Cloud Console",
        "modifyNote": "To modify schedules, use Google Cloud Console",
        "editTitle": "Edit Schedule",
        "editNotAvailable": "Schedule Editing Not Available",
        "editNotAvailableMessage": "Schedule modifications require Cloud Scheduler API integration. Please use the 'View in Cloud Console' button to modify schedules directly in Google Cloud Console.",
        "cronExpression": "Cron Expression",
        "cronHint": "Format: minute hour day month weekday (e.g., 0 2 * * * = daily at 2:00 AM)",
        "patterns": {
          "daily": "Daily at {{hour}}:{{minute}}",
          "weekly": "Every {{day}} at {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "Sunday",
          "monday": "Monday",
          "tuesday": "Tuesday",
          "wednesday": "Wednesday",
          "thursday": "Thursday",
          "friday": "Friday",
          "saturday": "Saturday"
        }
      },
      "reports": {
        "title": "Recent Audit Reports",
        "emptyMessage": "No audit reports yet",
        "totalReports": "{{count}} report(s)",
        "clearAll": "Clear All",
        "confirmClearAll": "Are you sure you want to clear all audit reports? This action cannot be undone.",
        "clearedSuccessfully": "All audit reports cleared successfully",
        "viewLogs": "View Logs",
        "viewDetails": "View Details",
        "columns": {
          "date": "Date",
          "type": "Type",
          "duration": "Duration",
          "status": "Status",
          "issues": "Issues",
          "fixes": "Fixes",
          "actions": "Actions"
        },
        "detailModal": {
          "title": "Audit Report: {{id}}",
          "summary": "Summary",
          "status": "Status",
          "executionTime": "Execution Time",
          "totalItems": "Total Items",
          "healthyItems": "Healthy Items",
          "issuesFound": "Issues Found",
          "totalIssues": "Total Issues Found",
          "seeInsightsBelow": "See AI Insights below for details",
          "brokenStreams": "Broken Streams",
          "missingMetadata": "Missing Metadata",
          "misclassifications": "Misclassifications",
          "orphanedItems": "Orphaned Items",
          "fixesApplied": "Fixes Applied",
          "totalFixes": "{{count}} total fixes",
          "aiInsights": "AI Insights"
        }
      },
      "logs": {
        "title": "Execution Logs",
        "liveAuditLog": "Live Audit Log",
        "executionLog": "Audit Execution Log",
        "searchPlaceholder": "Search logs...",
        "noLogs": "No logs to display",
        "noActiveAudit": "No Active Audit",
        "triggerAuditToSee": "Trigger an audit to see live execution logs here",
        "auditType": "Audit Type",
        "started": "Started",
        "completed": "Completed",
        "lastLog": "Last log",
        "staleWarning": "No new logs for {{seconds}}s - job may be processing or stuck",
        "pollingStatus": "Polling active • Last checked",
        "connecting": "Connecting to live audit log...",
        "aiInsightPrefix": "AI Insight",
        "source": {
          "librarian": "Librarian",
          "aiAgent": "AI Agent"
        },
        "levels": {
          "debug": "DEBUG",
          "info": "INFO",
          "warn": "WARN",
          "error": "ERROR",
          "success": "SUCCESS",
          "trace": "TRACE"
        },
        "auditStarted": "Audit started",
        "brokenStreamsFound": "Found {{count}} broken stream(s)",
        "missingMetadataFound": "Found {{count}} item(s) with missing metadata",
        "misclassificationsFound": "Found {{count}} misclassified item(s)",
        "orphanedItemsFound": "Found {{count}} orphaned item(s)",
        "fixesApplied": "Applied {{count}} fix(es)",
        "auditCompleted": "Audit {{status}} in {{duration}}s",
        "auditInitializing": "🚀 Initializing {{auditType}} audit...",
        "dryRunMode": "⚠️ Running in DRY RUN mode - no changes will be made",
        "liveMode": "✅ Running in LIVE mode - changes will be applied",
        "budgetSet": "💰 Budget limit: ${{budget}}",
        "connectingToAgent": "🔗 Connecting to Claude AI Agent..."
      },
      "audit": {
        "types": {
          "aiAgent": "AI Agent",
          "dailyIncremental": "Daily Incremental"
        },
        "pause": "Pause",
        "resume": "Resume",
        "cancel": "Cancel",
        "interject": "Interject",
        "interjectTitle": "Send Message to AI Agent",
        "interjectHint": "This message will be injected into the AI agent conversation at the next iteration. Use it to provide additional context, redirect focus, or give specific instructions.",
        "interjectPlaceholder": "e.g., Focus only on movies, skip series for now...",
        "sendInterject": "Send",
        "interjectSuccess": "Message sent to AI agent successfully",
        "pauseSuccess": "Audit paused successfully",
        "resumeSuccess": "Audit resumed successfully",
        "cancelSuccess": "Audit cancelled successfully"
      },
      "progress": {
        "batch": "Batch {{current}} of {{total}}",
        "items": "{{processed}} of {{total}} items",
        "finishing": "Finishing up...",
        "finalizing": "Generating report and applying fixes"
      },
      "activityLog": {
        "title": "Activity Log",
        "subtitle": "{{count}} actions recorded",
        "filterByType": "Filter by type",
        "allActions": "All Actions",
        "content": "Content",
        "noDescription": "No description available",
        "updatedFields": "Updated {{fields}}",
        "pagination": "Page {{page}} of {{totalPages}}",
        "issueType": "Issue Type",
        "confidence": "Confidence",
        "autoApproved": "Auto-approved",
        "changes": "Changes",
        "actionTypes": {
          "addPoster": "Add Poster",
          "updateMetadata": "Update Metadata",
          "recategorize": "Recategorize",
          "fixUrl": "Fix URL",
          "cleanTitle": "Clean Title",
          "classify": "Classify"
        },
        "rollback": "Rollback",
        "rolledBack": "Rolled Back",
        "confirmRollback": {
          "title": "Confirm Rollback",
          "message": "Are you sure you want to rollback this action? This will restore the previous state."
        },
        "emptyMessage": "No actions found"
      },
      "modal": {
        "confirmAI": {
          "title": "Trigger AI Agent Audit?",
          "message": "This will trigger an autonomous AI agent audit with a budget limit of ${{budget}}. The agent will make decisions about what to check and fix. {{dryRun}}",
          "dryRunNote": "Running in DRY RUN mode (no changes will be made)."
        },
        "cancel": "Cancel",
        "confirm": "Confirm",
        "close": "Close",
        "retry": "Retry"
      },
      "status": {
        "enabled": "ENABLED",
        "disabled": "DISABLED",
        "completed": "Audit Complete",
        "failed": "Audit Failed",
        "in_progress": "In Progress",
        "partial": "Partially Complete",
        "pending": "Pending",
        "running": "Running"
      },
      "auditTypes": {
        "daily_incremental": "daily incremental",
        "ai_agent": "AI Agent"
      }
    },
    "widgets": {
      "title": "Widgets",
      "subtitle": "Manage floating overlay widgets for live streams and embeds",
      "newWidget": "New Widget",
      "editWidget": "Edit Widget",
      "columns": {
        "title": "Title",
        "contentType": "Content Type",
        "targetRoles": "Target Roles",
        "targetPages": "Target Pages",
        "status": "Status",
        "order": "Order"
      },
      "contentTypes": {
        "liveChannel": "Live Channel",
        "live": "Live",
        "vod": "Video on Demand",
        "podcast": "Podcast",
        "radio": "Radio",
        "iframe": "Iframe"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "form": {
        "title": "Widget title",
        "description": "Description (optional)",
        "icon": "Icon emoji (optional)",
        "contentType": "Content Type",
        "selectChannel": "Select Live Channel",
        "channelPlaceholder": "-- Select Channel --",
        "iframeUrl": "Iframe URL",
        "iframeTitle": "Iframe title (for accessibility)",
        "position": "Default Position",
        "behavior": "Behavior",
        "mutedByDefault": "Muted by default",
        "closable": "Closable",
        "draggable": "Draggable",
        "targetPages": "Target Pages (comma-separated, empty = all)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "Order"
      },
      "actions": {
        "save": "Save",
        "cancel": "Cancel"
      },
      "confirmDelete": "Are you sure you want to delete this widget?",
      "emptyMessage": "No widgets found. Create one to get started.",
      "allPages": "All pages",
      "allRoles": "All",
      "errors": {
        "titleRequired": "Title is required",
        "selectChannel": "Please select a live channel",
        "iframeUrlRequired": "Iframe URL is required"
      }
    },
    "billing": {
      "subtitle": "Track revenue and payments",
      "revenue": "Revenue",
      "today": "Today",
      "thisWeek": "This Week",
      "thisMonth": "This Month",
      "thisYear": "This Year",
      "metrics": "Key Metrics",
      "totalTransactions": "Total Transactions",
      "avgTransaction": "Avg Transaction",
      "pendingRefunds": "Pending Refunds",
      "refundRate": "Refund Rate",
      "retention": "Retention",
      "retentionRate": "Retention Rate",
      "churnRate": "Churn Rate",
      "atRiskUsers": "At Risk Users",
      "churnedUsers": "Churned Users",
      "quickLinks": "Quick Links"
    },
    "marketing": {
      "recentCampaigns": "Recent Campaigns",
      "audienceSegments": "Audience Segments",
      "emailMetrics": "Email Metrics",
      "pushMetrics": "Push Metrics",
      "quickActions": "Quick Actions"
    },
    "push": {
      "titlePlaceholder": "Notification Title",
      "bodyPlaceholder": "Notification Message"
    },
    "auditLogs": {
      "subtitle": "Track all system actions",
      "filter": "Filter",
      "export": "Export",
      "all": "All",
      "advancedFiltering": "Advanced Filtering",
      "actionType": "Action Type",
      "clear": "Clear",
      "apply": "Apply",
      "noRecords": "No records found",
      "columns": {
        "action": "Action",
        "user": "User",
        "resource": "Resource",
        "details": "Details",
        "date": "Date",
        "ip": "IP"
      },
      "changed": "Changed",
      "actionFilters": {
        "user": "User",
        "subscription": "Subscription",
        "payment": "Payment",
        "settings": "Settings",
        "campaign": "Campaign",
        "content": "Content"
      }
    },
    "settings": {
      "subtitle": "Configure system parameters",
      "saveChanges": "Save Changes",
      "generalSettings": "General Settings",
      "supportEmail": "Support Email",
      "defaultPlan": "Default Plan",
      "termsUrl": "Terms of Service URL",
      "privacyUrl": "Privacy Policy URL",
      "userSettings": "User Settings",
      "maxDevices": "Maximum Devices per Account",
      "trialDays": "Trial Period Days",
      "maintenanceMode": "Maintenance Mode",
      "maintenanceModeDesc": "When enabled, the system will be inaccessible to users",
      "featureFlags": "Feature Flags",
      "systemActions": "System Actions",
      "clearCache": "Clear Cache",
      "resetAnalytics": "Reset Analytics",
      "actionsWarning": "These actions may affect system performance. Use with caution.",
      "savingSuccess": "Settings saved successfully",
      "confirmClearCache": "Clear cache? This may temporarily affect performance.",
      "cacheCleared": "Cache cleared successfully",
      "confirmResetAnalytics": "Reset analytics data? This action cannot be undone!",
      "analyticsReset": "Analytics data has been reset",
      "featureFlagLabels": {
        "new_player": "New Player",
        "live_chat": "Live Chat",
        "downloads": "Downloads",
        "watch_party": "Watch Party",
        "voice_search": "Voice Search",
        "ai_recommendations": "AI Recommendations"
      }
    },
    "content": {
      "title": "Content Library",
      "subtitle": "Manage movies, series, and video content",
      "importFree": "Import Free Content",
      "searchPlaceholder": "Search content...",
      "emptyMessage": "No content found",
      "confirmDelete": "Delete this content?",
      "confirmBatchDelete": "Are you sure you want to delete {{count}} item(s)?",
      "selectedItems": "{{count}} item(s) selected",
      "batchFeature": "Feature",
      "batchUnfeature": "Unfeature",
      "import": {
        "pageTitle": "Import Free Content",
        "subtitle": "Browse and import public content from free sources",
        "selectCategory": "Select category for imported movies:",
        "categoryPlaceholder": "Select a category...",
        "loading": "Loading sources...",
        "sourceTypes": {
          "vod": "Movies & VOD",
          "live_tv": "Live TV",
          "radio": "Radio",
          "podcasts": "Podcasts"
        },
        "items": "item",
        "itemsPlural": "items",
        "selectItems": "Please select at least one item to import",
        "selectCategory_vod": "Please select a category for VOD imports",
        "importing": "Importing {{count}}... {{percent}}%",
        "importButton": "Import {{count}} {{item}}",
        "noSources": "No Sources Available",
        "noSourcesDescription": "No free content sources are currently available for {{type}}"
      },
      "filters": {
        "title": "Filters",
        "contentType": "Content Type",
        "all": "All",
        "allContent": "All",
        "series": "Series",
        "movies": "Movies",
        "podcasts": "Podcasts",
        "radioStations": "Radio Stations",
        "status": "Status",
        "allStatus": "All Status",
        "subtitles": "Subtitles"
      },
      "podcastsComingSoon": "Podcast management coming soon. Use the Podcasts section.",
      "radioComingSoon": "Radio station management coming soon. Use the Radio Stations section.",
      "showOnlyWithSubtitles": "Show only with subtitles",
      "status": {
        "published": "Published",
        "draft": "Draft"
      },
      "columns": {
        "title": "Title",
        "category": "Category",
        "year": "Year",
        "status": "Status",
        "views": "Views",
        "rating": "Rating",
        "streamUrl": "Stream URL",
        "epgSource": "EPG Source",
        "genre": "Genre",
        "episodeNumber": "Episode #",
        "description": "Description",
        "duration": "Duration",
        "publishedDate": "Published",
        "episodes": "Episodes",
        "order": "Order",
        "name": "Name",
        "slug": "Slug",
        "subtitles": "Subtitles"
      },
      "validation": {
        "titleRequired": "Title is required",
        "nameRequired": "Name is required",
        "streamUrlRequired": "Stream URL is required",
        "audioUrlRequired": "Audio URL is required"
      },
      "episodes_one": "episode",
      "episodes_other": "episodes",
      "noEpisodes": "No episodes found",
      "type": {
        "series": "Series",
        "movie": "Movie"
      },
      "toggleCarousel": "Toggle carousel",
      "editor": {
        "pageTitle": "Edit Content",
        "pageTitleNew": "Add Content",
        "sections": {
          "basicInfo": "Basic Information",
          "media": "Media",
          "streaming": "Streaming",
          "details": "Content Details",
          "publishing": "Publishing",
          "accessControl": "Access Control",
          "podcastDetails": "Podcast Details",
          "episodeDetails": "Episode Details",
          "stationDetails": "Station Details",
          "channelDetails": "Channel Details"
        },
        "fields": {
          "title": "Title",
          "titlePlaceholder": "Content title",
          "titleRequired": "Title is required",
          "year": "Year",
          "yearPlaceholder": "2024",
          "description": "Description",
          "descriptionPlaceholder": "Content description",
          "thumbnail": "Thumbnail (3:4 aspect ratio)",
          "thumbnailUrl": "Thumbnail URL",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "Backdrop (16:9 aspect ratio)",
          "backdropUrl": "Backdrop URL",
          "posterCover": "Podcast Cover",
          "logo": "Logo",
          "channelLogo": "Channel Logo",
          "stationLogo": "Station Logo",
          "streamUrl": "Stream URL",
          "streamUrlRequired": "Stream URL is required",
          "streamType": "Stream Type",
          "drmProtected": "DRM Protected",
          "drmProtectedLabel": "This content requires DRM protection",
          "category": "Category",
          "categoryRequired": "Category is required",
          "duration": "Duration",
          "durationPlaceholder": "1:30:00",
          "rating": "Rating",
          "ratingPlaceholder": "PG-13",
          "genre": "Genre",
          "genrePlaceholder": "Drama",
          "director": "Director",
          "directorPlaceholder": "Director name",
          "isSeries": "Series",
          "isSeriesLabel": "This is a series/multi-part content",
          "season": "Season",
          "episode": "Episode",
          "seriesId": "Series ID",
          "seriesIdPlaceholder": "series-identifier",
          "isPublished": "Publish",
          "isPublishedLabel": "Publish this content immediately",
          "isFeatured": "Feature",
          "isFeaturedLabel": "Feature this content on homepage",
          "requiresSubscription": "Required Subscription",
          "isKidsContent": "Kids Content",
          "isKidsContentLabel": "This is kids-friendly content",
          "author": "Author",
          "authorPlaceholder": "Podcast author",
          "podcastCategory": "Category",
          "podcastCategoryPlaceholder": "News, Science, etc.",
          "rssFeed": "RSS Feed URL",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "Website URL",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "Episode #",
          "seasonNumber": "Season #",
          "audioUrl": "Audio URL",
          "audioUrlRequired": "Audio URL is required",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "Published Date",
          "epgSource": "EPG Source URL",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "Current Show",
          "currentShowPlaceholder": "Show name",
          "nextShow": "Next Show",
          "nextShowPlaceholder": "Show name",
          "currentSong": "Current Song",
          "currentSongPlaceholder": "Song title",
          "isActive": "Active",
          "isActiveLabel": "Channel is active",
          "requiredSubscription": "Required Subscription",
          "publishedDate": "Published Date"
        },
        "subscriptionTiers": {
          "basic": "Basic",
          "premium": "Premium",
          "family": "Family"
        },
        "actions": {
          "save": "Save",
          "saving": "Saving...",
          "cancel": "Cancel"
        },
        "imageUpload": {
          "dropHere": "Drop image here or click to upload",
          "formats": "PNG, JPG, WebP up to {{maxSize}}MB",
          "uploading": "Uploading...",
          "success": "Image uploaded successfully",
          "orPasteUrl": "Or paste image URL",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "Add",
          "validating": "Validating...",
          "clear": "Remove image",
          "errors": {
            "imageOnly": "Please select an image file",
            "tooLarge": "File size must be less than {{maxSize}}MB",
            "uploadFailed": "Upload failed",
            "invalidUrl": "Invalid URL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "Select category...",
        "searchPlaceholder": "Search categories...",
        "loading": "Loading categories...",
        "noResults": "No categories found",
        "noCategories": "No categories available",
        "createNew": "Create new category",
        "errors": {
          "loadFailed": "Failed to load categories",
          "createFailed": "Failed to create category"
        },
        "modal": {
          "title": "Create New Category",
          "placeholder": "Category name (e.g., Movies, Series)",
          "creating": "Creating...",
          "create": "Create"
        }
      },
      "streamUrlInput": {
        "copyUrl": "Copy URL",
        "copied": "URL copied to clipboard",
        "streamType": "Stream Type",
        "validUrl": "URL is valid - detected as {{type}}",
        "errors": {
          "required": "Stream URL is required",
          "invalidFormat": "Invalid URL format"
        },
        "supportedFormats": {
          "title": "Supported formats:",
          "hls": "HLS: .m3u8 streams",
          "dash": "DASH: .mpd streams",
          "audio": "Audio: .mp3, .aac, or audio streams"
        }
      }
    },
    "categories": {
      "subtitle": "Manage content categories",
      "emptyMessage": "No categories found",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "form": {
        "nameHebrew": "Category name (Hebrew)",
        "nameEnglish": "Category name (English)",
        "slug": "Slug"
      }
    },
    "liveChannels": {
      "subtitle": "Manage live TV channels",
      "emptyMessage": "No live channels found",
      "subtitleSettings": "Live Subtitle Settings",
      "form": {
        "name": "Channel name",
        "streamUrl": "Stream URL",
        "epgSource": "EPG Source URL (optional)",
        "currentShow": "Current Show",
        "order": "Order",
        "supportsSubtitles": "Enable Live Subtitles",
        "primaryLanguage": "Primary Language (Source)",
        "targetLanguages": "Available Translation Languages",
        "targetLanguagesHelp": "Select which languages users can translate to in real-time"
      }
    },
    "radioStations": {
      "subtitle": "Manage radio stations",
      "emptyMessage": "No radio stations found",
      "form": {
        "name": "Station name",
        "genre": "Genre",
        "streamUrl": "Stream URL",
        "currentShow": "Current Show (optional)",
        "currentSong": "Current Song (optional)",
        "order": "Order"
      }
    },
    "podcasts": {
      "subtitle": "Manage podcasts and episodes",
      "episodesSubtitle": "Manage episodes",
      "emptyMessage": "No podcasts found",
      "noEpisodes": "No episodes found",
      "form": {
        "title": "Podcast title",
        "author": "Author",
        "description": "Description",
        "category": "Category",
        "rssFeed": "RSS Feed URL",
        "website": "Website URL (optional)"
      },
      "episodes": {
        "form": {
          "title": "Episode title",
          "description": "Description",
          "episodeNumber": "Episode number",
          "seasonNumber": "Season number (optional)",
          "duration": "Duration",
          "audioUrl": "Audio URL (required)",
          "publishedDate": "Published Date (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "Manage users and accounts",
      "addUser": "Add User",
      "status": {
        "active": "Active",
        "inactive": "Inactive",
        "blocked": "Blocked"
      },
      "filters": {
        "all": "All",
        "active": "Active",
        "inactive": "Inactive",
        "blocked": "Blocked"
      },
      "columns": {
        "name": "Name",
        "role": "Role",
        "subscription": "Subscription",
        "noSubscription": "No Subscription",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "confirmDelete": "Delete User",
      "confirmDeleteMessage": "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "resetPassword": "Reset Password",
      "block": "Block",
      "unban": "Unban",
      "confirmResetPassword": "Send password reset email to {{email}}?",
      "resetPasswordSent": "Password reset email sent",
      "recentActivity": "Recent Activity",
      "noActivity": "No activity",
      "notFound": "User not found",
      "backToList": "Back to list",
      "banReason": "Ban reason",
      "banReasonPrompt": "Ban reason:",
      "confirmUnban": "Unban user?",
      "userDetails": "User Details",
      "id": "ID",
      "registered": "Registered",
      "billingHistory": "Billing History",
      "noPayments": "No payments"
    },
    "campaigns": {
      "subtitle": "Manage coupon codes and discounts",
      "expired": "Expired",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "columns": {
        "name": "Name",
        "discount": "Discount",
        "usage": "Uses",
        "validUntil": "Valid Until",
        "status": "Status",
        "actions": "Actions"
      },
      "confirmDelete": "Delete Campaign",
      "confirmDeleteMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "searchPlaceholder": "Search campaigns...",
      "emptyMessage": "No campaigns found",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "createTitle": "New Campaign",
      "editTitle": "Edit Campaign",
      "formSubtitle": "Set up a coupon code or discount",
      "form": {
        "name": "Campaign Name",
        "namePlaceholder": "e.g. Summer Sale 2024",
        "code": "Coupon Code",
        "generate": "Generate",
        "discountType": "Discount Type",
        "discountValue": "Discount Value",
        "maxUses": "Maximum Uses",
        "unlimited": "Unlimited",
        "validUntil": "Valid Until",
        "active": "Campaign Active"
      }
    },
    "subscriptions": {
      "subtitle": "View and manage system subscribers",
      "status": {
        "active": "Active",
        "paused": "Paused",
        "cancelled": "Cancelled",
        "expired": "Expired"
      },
      "columns": {
        "user": "User",
        "plan": "Plan",
        "price": "Price",
        "nextBilling": "Next Billing",
        "status": "Status"
      },
      "perMonth": "/month",
      "searchPlaceholder": "Search subscription...",
      "emptyMessage": "No subscriptions found",
      "actions": {
        "changePlan": "Change Plan",
        "pause": "Pause",
        "resume": "Resume",
        "cancel": "Cancel",
        "delete": "Delete"
      },
      "editPlan": {
        "title": "Change Subscription Plan",
        "user": "User",
        "currentPlan": "Current Plan",
        "newPlan": "Select New Plan"
      },
      "addSubscription": {
        "title": "Add Subscription",
        "userEmail": "User Email",
        "emailPlaceholder": "Enter user email",
        "duration": "Duration (days)",
        "selectPlan": "Select Plan"
      },
      "fillAllFields": "Please fill all fields",
      "userNotFound": "User not found",
      "selectOneToEdit": "Please select exactly one subscription to edit",
      "selectToDelete": "Please select subscriptions to delete",
      "confirmDeleteMultiple": "Delete {{count}} subscription(s)?",
      "selected": "selected",
      "confirmDelete": "Are you sure you want to delete the subscription for {{user}}? This action cannot be undone."
    },
    "marketingDashboard": {
      "subtitle": "Marketing Overview",
      "refresh": "Refresh",
      "totalSubscribers": "Total Subscribers",
      "emailOpenRate": "Email Open Rate",
      "pushClickRate": "Push Click Rate",
      "activeSegments": "Active Segments",
      "campaignStatus": {
        "active": "Active",
        "completed": "Completed",
        "scheduled": "Scheduled",
        "draft": "Draft"
      }
    },
    "transactions": {
      "subtitle": "View payment history",
      "exportCsv": "Export CSV",
      "status": {
        "completed": "Completed",
        "pending": "Pending",
        "failed": "Failed",
        "refunded": "Refunded"
      },
      "columns": {
        "id": "ID",
        "user": "User",
        "amount": "Amount",
        "type": "Type",
        "status": "Status",
        "date": "Date"
      },
      "filters": {
        "all": "All"
      },
      "searchPlaceholder": "Search transaction...",
      "emptyMessage": "No transactions found",
      "details": "Transaction Details",
      "email": "Email"
    },
    "pushNotifications": {
      "subtitle": "Create and send notifications to users",
      "newNotification": "New Notification",
      "status": {
        "draft": "Draft",
        "sent": "Sent",
        "scheduled": "Scheduled"
      },
      "columns": {
        "title": "Title",
        "status": "Status",
        "sent": "Sent",
        "opened": "Opened",
        "scheduledAt": "Scheduled At",
        "created": "Created",
        "actions": "Actions"
      },
      "filters": {
        "all": "All"
      },
      "searchPlaceholder": "Search notification...",
      "emptyMessage": "No notifications found",
      "createModal": "New Push Notification",
      "editModal": "Edit Notification",
      "scheduleModal": "Schedule Notification",
      "titleLabel": "Title",
      "bodyLabel": "Body",
      "dateTimeLabel": "Date and Time",
      "cancel": "Cancel",
      "create": "Create Notification",
      "schedule": "Schedule",
      "send": "Send Now",
      "confirmSend": "Send notification \"{{title}}\"?",
      "confirmDelete": "Delete notification \"{{title}}\"?",
      "fillRequired": "Please fill in title and body"
    }
  },
  "placeholder": {
    "email": "your@email.com",
    "password": "••••••••",
    "pin": "••••",
    "dateRange": {
      "from": "From (YYYY-MM-DD)",
      "to": "To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "Min",
      "max": "Max",
      "price": "0.00"
    },
    "chatMessage": "Type here...",
    "deepLink": "bayitplus://content/123",
    "scheduleDateTime": "YYYY-MM-DDTHH:mm",
    "roomCode": "ABCD1234",
    "time": {
      "start": "08:00",
      "end": "10:00"
    },
    "filter": {
      "userId": "Enter user ID"
    },
    "datetime": "YYYY-MM-DDTHH:mm",
    "number": "0",
    "chat": "Type your message..."
  },
  "components": {
    "select": {
      "default": "Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "Basic",
      "features": [
        "All VOD content",
        "Radio & Podcasts",
        "Watch on 1 device",
        "SD quality"
      ],
      "notIncluded": [
        "Live channels",
        "AI Assistant",
        "Offline viewing"
      ]
    },
    "premium": {
      "name": "Premium",
      "features": [
        "All VOD content",
        "Live channels",
        "Radio & Podcasts",
        "Smart AI Assistant",
        "Watch on 2 devices",
        "HD quality"
      ],
      "notIncluded": [
        "Offline viewing",
        "Family profiles"
      ]
    },
    "family": {
      "name": "Family",
      "features": [
        "All VOD content",
        "Live channels",
        "Radio & Podcasts",
        "Smart AI Assistant",
        "Watch on 4 devices",
        "4K quality",
        "5 family profiles",
        "Download for offline"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "{{count}} selected",
      "selectedCount_one": "{{count}} selected",
      "selectedCount_other": "{{count}} selected",
      "clear": "Clear"
    },
    "costDashboard": {
      "title": "Cost Dashboard",
      "costBreakdown": "Cost Breakdown",
      "loadingBreakdown": "Loading breakdown...",
      "aiCosts": "AI Costs",
      "infrastructure": "Infrastructure",
      "thirdParty": "Third-party",
      "thirdPartyApis": "Third-party APIs",
      "translation": "Translation",
      "search": "Search",
      "percentOfTotal": "% of total",
      "components": "Components",
      "topSpenders": {
        "title": "Top 20 Spenders (Monthly)",
        "loading": "Loading top spenders...",
        "rank": "Rank",
        "userId": "User ID",
        "costRange": "Cost Range",
        "privacyNote": "User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "Permanent",
        "transient": "Transient",
        "permanentVsTransient": "Permanent vs Transient",
        "permanentFixed": "Permanent (Fixed)",
        "transientVariable": "Transient (Variable)",
        "permanentDesc": "Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "Detailed Breakdown",
        "costItem": "Cost Item",
        "category": "Category",
        "amount": "Amount"
      },
      "timeline": {
        "title": "Cost Timeline",
        "loading": "Loading timeline...",
        "amountLabel": "Amount ($)",
        "revenue": "Revenue",
        "totalCost": "Total Cost",
        "netProfit": "Net Profit",
        "showingData": "Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "Net Profit/Loss",
        "margin": "margin",
        "revenue": "REVENUE",
        "totalCosts": "TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "Choose Your Plan",
    "subtitle": "7 days free trial for any plan. Cancel anytime.",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "save2Months": "Save 2 months",
    "popular": "Most Popular",
    "period": "/month",
    "perYear": "/year",
    "select": "Select Plan",
    "selected": "Selected",
    "processing": "Processing...",
    "startTrial": "Start Free Trial",
    "noCharge": "Your credit card won't be charged during the trial period"
  },
  "notFound": {
    "title": "Page Not Found",
    "description": "The page you're looking for doesn't exist or has been moved.",
    "homeButton": "Go Home",
    "searchButton": "Search",
    "orTry": "Or try:",
    "liveChannel": "Live",
    "vodLabel": "Movies",
    "podcastsLabel": "Podcasts"
  },
  "profiles": {
    "addProfile": "Add Profile",
    "enterPin": "Enter PIN",
    "selectError": "Error selecting profile",
    "wrongPin": "Incorrect PIN",
    "loading": "Loading profiles...",
    "manage": "Manage Profiles",
    "whoIsWatching": "Who's Watching?",
    "manageProfiles": "Manage Profiles",
    "kids": "Kids",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "Content not found",
    "backToHome": "Back to Home",
    "episodes": "Episodes",
    "addToList": "Add to List",
    "like": "Like",
    "share": "Share",
    "cast": "Cast",
    "episodesList": "Episodes",
    "schedule": "Schedule",
    "now": "Now",
    "related": "Related Content",
    "deleteEpisode": "Delete Episode",
    "confirmDeleteEpisode": "Delete this episode?"
  },
  "live": {
    "title": "Live TV",
    "next": "Next:",
    "noChannels": "No channels available",
    "tryLater": "Try again later",
    "categories": {
      "all": "All",
      "news": "News",
      "entertainment": "Entertainment",
      "sports": "Sports",
      "kids": "Kids",
      "music": "Music"
    }
  },
  "judaism": {
    "title": "Judaism",
    "items": "items",
    "empty": "No content available",
    "emptyHint": "Try selecting another category",
    "dashboard": "Your Jewish Dashboard",
    "categories": {
      "news": "Jewish News",
      "community": "Community"
    },
    "shabbat": {
      "title": "Shabbat Times",
      "shabbatShalom": "Shabbat Shalom!",
      "shabbatMode": "Shabbat Mode",
      "endsIn": "Shabbat ends in",
      "candleLighting": "Candle Lighting",
      "havdalah": "Havdalah",
      "parashat": "Parashat",
      "friday": "Friday",
      "saturday": "Saturday",
      "noData": "Unable to load Shabbat times"
    },
    "erevShabbat": {
      "title": "Erev Shabbat",
      "prepareFor": "Prepare for Shabbat",
      "inTime": "in {{time}}",
      "featuredContent": "Shabbat Content",
      "noContent": "Shabbat content coming soon!",
      "shabbatShalom": "Shabbat Shalom!",
      "timeUntil": "Time until Shabbat",
      "shabbatSongs": "Shabbat Songs",
      "parashaStudy": "Parasha",
      "shabbatRecipes": "Recipes",
      "prayers": "Prayers"
    }
  },
  "children": {
    "title": "Kids",
    "items": "items",
    "empty": "No content available",
    "emptyHint": "Try another category",
    "exitKidsMode": "Exit Kids Mode",
    "exitDescription": "Enter parent code to exit",
    "parentCode": "Parent code",
    "confirm": "Confirm",
    "wrongCode": "Incorrect code",
    "noContent": "No content available",
    "tryAnotherCategory": "Try selecting another category",
    "categories": {
      "all": "All",
      "cartoons": "Cartoons",
      "educational": "Educational",
      "music": "Music",
      "hebrew": "Hebrew",
      "stories": "Stories",
      "jewish": "Jewish"
    },
    "ageRatings": {
      "3": "Ages 3+",
      "5": "Ages 5+",
      "7": "Ages 7+",
      "10": "Ages 10+",
      "12": "Ages 12+"
    },
    "moderation": {
      "pending": "Pending Review",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "admin": {
      "stats": "Kids Content Manager",
      "seedContent": "Seed Content",
      "importArchive": "Import Archive.org",
      "syncPodcasts": "Sync Podcasts",
      "syncYouTube": "Sync YouTube",
      "tagVod": "Tag VOD",
      "pendingModeration": "Pending Moderation"
    }
  },
  "youngsters": {
    "title": "Youngsters",
    "items": "items",
    "empty": "No content available",
    "emptyHint": "Try another category",
    "exitYoungstersMode": "Exit Youngsters Mode",
    "exitDescription": "Enter parent code to exit",
    "parentCode": "Parent code",
    "confirm": "Confirm",
    "wrongCode": "Incorrect code",
    "noContent": "No content available",
    "tryAnotherCategory": "Try selecting another category",
    "categories": {
      "all": "All",
      "trending": "Trending",
      "news": "News",
      "culture": "Culture",
      "educational": "Educational",
      "music": "Music",
      "entertainment": "Entertainment",
      "sports": "Sports",
      "tech": "Technology",
      "judaism": "Judaism"
    },
    "ageGroups": {
      "middle-school": "Middle School (12-14)",
      "high-school": "High School (15-17)"
    },
    "moderation": {
      "pending": "Pending Review",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "admin": {
      "stats": "Youngsters Content Manager",
      "seedContent": "Seed Content",
      "importArchive": "Import Archive.org",
      "syncPodcasts": "Sync Podcasts",
      "syncYouTube": "Sync YouTube",
      "tagVod": "Tag VOD",
      "pendingModeration": "Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Bayit+ Assistant",
    "greeting": "Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "openChat": "Open chat",
    "welcome": "Hello! I'm the Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "placeholder": "Type here...",
    "recording": "Recording... click again to stop",
    "transcribing": "Transcribing...",
    "stopRecording": "Stop recording",
    "startRecording": "Start voice recording",
    "recommendations": "Here are some recommendations:",
    "showMultipleSuccess": "Showing {{count}} content items in widgets",
    "showMultipleNotFound": "Could not find the requested content. Please try different names.",
    "resolvingContent": "Finding your content...",
    "errors": {
      "micPermission": "Could not access microphone. Please check microphone permissions in your browser.",
      "transcribeFailed": "Could not transcribe the recording. Please try again.",
      "general": "Sorry, something went wrong. Please try again."
    },
    "suggestions": {
      "whatToWatch": "What to watch today?",
      "israeliMovies": "Recommended Israeli movies",
      "whatsOnNow": "What's on now?",
      "popularPodcasts": "Popular podcasts"
    },
    "voiceCommands": {
      "showChannels": "Show me channels...",
      "playChess": "Start a chess game with...",
      "multiContent": "Show side by side..."
    }
  },
  "chat": {
    "title": "Bayit+ Assistant",
    "greeting": "Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "Nikud",
    "selection": "Selection",
    "translation": "Translation",
    "translating": "Translating...",
    "close": "Close",
    "unavailable": "Translation unavailable",
    "off": "Off",
    "none": "None",
    "autoGenerated": "Auto-generated",
    "selectLanguage": "Select Subtitle Language",
    "liveTranslate": "Live Translate",
    "translateTo": "Translate To",
    "downloadMore": "Download more subtitles...",
    "downloading": "Searching OpenSubtitles...",
    "opensubtitlesSource": "From OpenSubtitles.com",
    "downloadSuccess": "Downloaded {{count}} subtitle(s)",
    "noSubtitlesFound": "No subtitles found for this content",
    "smartSubs": "Smart Subs",
    "smartSubsDescription": "Dual-view: Simplified Hebrew + English with root highlighting",
    "smartSubsDualView": "Dual View",
    "shoreshToggle": "Root Highlighting",
    "shoreshOn": "Shoresh highlighting enabled",
    "shoreshOff": "Shoresh highlighting disabled",
    "nikudLive": "Hebrew with Nikud",
    "nikudLiveDescription": "Vocalized Hebrew subtitles with diacritical marks for easier reading",
    "nikudEnabled": "Nikud subtitles enabled",
    "nikudDisabled": "Nikud subtitles disabled",
    "nikudSubtitleLabel": "Hebrew with nikud: {{text}}",
    "available": "Subtitles",
    "clickToEnable": "Click to enable live translation",
    "connectionError": "Live Translation Error",
    "inputLanguageTooltip": "Check Input Language",
    "premiumRequired": "Premium subscription required",
    "selectInputLanguage": "Select input language",
    "translateActive": "Live Translation Active",
    "noEnglishSubtitles": "No English subtitles available for this content.",
    "hebrewMode": {
      "title": "Hebrew Display Mode",
      "unavailable": "Unavailable",
      "generate": "Generate",
      "regular": {
        "title": "Regular Hebrew",
        "description": "Standard Hebrew text without vowel marks"
      },
      "nikud": {
        "title": "Hebrew with Nikud",
        "description": "Vocalized Hebrew with vowel marks for easier reading",
        "unavailableReason": "AI processing not available for this content"
      },
      "shoresh": {
        "title": "Shoresh (Root Words)",
        "description": "Hebrew words with root analysis: word [root]",
        "unavailableReason": "Root word analysis not available for this content"
      }
    },
    "englishMode": {
      "title": "English Display Mode",
      "unavailable": "Unavailable",
      "generate": "Generate",
      "firstTimeHint": "These AI-powered modes help maintain Hebrew while learning English sentence structure. Each mode offers a unique learning experience.",
      "regular": {
        "title": "Regular English",
        "description": "Standard English subtitles"
      },
      "heblish": {
        "title": "Heblish",
        "description": "English with Hebrew word injections for immersive learning",
        "unavailableReason": "Heblish processing not available for this content"
      },
      "grammarFlip": {
        "title": "Grammar-Flip",
        "description": "Hebrew words with English sentence structure (Subject-Verb-Object)",
        "unavailableReason": "Grammar-Flip processing not available for this content"
      },
      "slangSynthesis": {
        "title": "Slang Synthesis",
        "description": "Modern Israeli and American slang blend for engaging content",
        "unavailableReason": "Slang Synthesis processing not available for this content"
      }
    },
    "loading": "Loading subtitles...",
    "error": {
      "title": "Subtitle Error",
      "retry": "Try Again",
      "loadFailed": "Failed to load subtitles",
      "cuesFailed": "Failed to load subtitle text",
      "networkError": "Network error - please check your connection",
      "serverError": "Server error - please try again later"
    },
    "aiModesAvailable": "AI modes available",
    "aiModesTitle": "AI Subtitle Modes",
    "fetchSubtitles": "Fetch Subtitles",
    "fontSize": "Font Size",
    "mode": {
      "engrew": "Engrew",
      "heblish": "Heblish",
      "shoresh": "Shoresh",
      "standard": "Standard"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "Search for external subtitles",
    "settingsTitle": "Subtitle Settings",
    "showBackground": "Show Background",
    "singleMode": "Single Mode",
    "splitMode": "Split Mode",
    "primary_language": "Primary Language",
    "secondary_language": "Secondary Language",
    "layout_mode": "Layout Mode",
    "interactive_title": "Interactive Subtitles"
  },
  "video": {
    "watchTrailer": "Watch Trailer",
    "closeTrailer": "Close Trailer",
    "deleteConfirm": "Delete this episode?"
  },
  "recordings": {
    "title": "My Recordings",
    "subtitle": "View and manage your recorded live streams",
    "record": "Record",
    "recording": "Recording",
    "storageUsed": "Storage Used",
    "totalRecordings": "Total Recordings",
    "maxDuration": "Max Duration",
    "noRecordings": "No Recordings Yet",
    "noRecordingsHint": "Start recording from any live channel!",
    "confirmDelete": "Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "Delete Recording",
    "deleteFailed": "Failed to delete recording",
    "expires": "Expires",
    "subtitlesAvailable": "Subtitles Available",
    "recordingSaved": "Recording Saved!",
    "savedSuccess": "Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "View in My Recordings",
    "error": "Recording Error",
    "startFailed": "Failed to start recording. Please try again.",
    "stopFailed": "Failed to stop recording. Please try again.",
    "page": "Page"
  },
  "chess": {
    "title": "Chess",
    "welcome": "Welcome to Chess",
    "subtitle": "Play chess with friends and family around the world",
    "createGame": "Create New Game",
    "joinGame": "Join Game",
    "gameCode": "Game Code",
    "enterGameCode": "Enter Game Code",
    "invalidGameCode": "Invalid game code. Must be 6 characters.",
    "joinFailed": "Failed to join game",
    "join": "Join",
    "create": "Create",
    "chooseColor": "Choose Your Color",
    "white": "White",
    "black": "Black",
    "chatPlaceholder": "Type a message... (@bot for advice)",
    "botHint": "Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "Chess Assistant",
    "mute": "Mute",
    "unmute": "Unmute",
    "speaking": "participants",
    "resign": "Resign",
    "offerDraw": "Offer Draw",
    "newGame": "New Game",
    "checkmate": "Checkmate!",
    "stalemate": "Stalemate",
    "draw": "Draw",
    "resigned": "Game Resigned",
    "reconnecting": "Reconnecting...",
    "moveHistory": "Move History",
    "noMoves": "No moves yet",
    "showHints": "Show Guide Hints",
    "yourTurn": "Your Turn",
    "opponentTurn": "Opponent's Turn",
    "waitingForOpponent": "Waiting for opponent...",
    "gameOver": "Game Over",
    "sendingInvite": "Sending game invite to {{name}}...",
    "inviteSent": "Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "Could not find that user. Please check the name and try again.",
    "inviteReceived": "{{name}} invited you to a chess game!",
    "joinInvite": "Join Game",
    "challenge": "Challenge",
    "playedAsWhite": "Played as White",
    "playedAsBlack": "Played as Black",
    "gameMode": "Game Mode",
    "playVsFriend": "Play vs Friend",
    "playVsBot": "Play vs Bot",
    "difficulty": "Difficulty",
    "easy": "Easy",
    "medium": "Medium",
    "hard": "Hard",
    "chessBot": "Chess Bot",
    "chat": {
      "title": "Chat",
      "inputPlaceholder": "Type a message..."
    },
    "acceptDraw": "Accept Draw",
    "acceptInvite": "Accept Invite",
    "blackCaptured": "Black Captured",
    "blackTurn": "Black's Turn",
    "challengeFriend": "Challenge Friend",
    "challengeViaWhatsApp": "Challenge via WhatsApp",
    "copyCode": "Copy Code",
    "declineDraw": "Decline Draw",
    "declineInvite": "Decline Invite",
    "drawOffered": "Draw Offered",
    "joinByGameCode": "Join by Game Code",
    "noFriendsYet": "No friends yet",
    "offline": "Offline",
    "online": "Online",
    "opponent": "Opponent",
    "whiteCaptured": "White Captured",
    "whiteTurn": "White's Turn",
    "you": "You"
  },
  "friends": {
    "title": "Friends & Opponents",
    "subtitle": "Connect with players and challenge friends",
    "myFriends": "My Friends",
    "requests": "Requests",
    "findPlayers": "Find Players",
    "friendsLabel": "Friends",
    "pendingLabel": "Pending",
    "add": "Add Friend",
    "remove": "Remove",
    "accept": "Accept",
    "reject": "Reject",
    "cancel": "Cancel",
    "noFriends": "No friends yet",
    "noFriendsDesc": "Search for players and send friend requests",
    "lastGame": "Last game: {{time}}",
    "friendsSince": "Friends since {{date}}",
    "incomingRequests": "Incoming Requests",
    "outgoingRequests": "Outgoing Requests",
    "noIncoming": "No incoming requests",
    "noOutgoing": "No outgoing requests",
    "sentAt": "Sent {{time}}",
    "searchPlaceholder": "Search by name...",
    "noResults": "No players found",
    "noResultsDesc": "Try searching with a different name",
    "requestSent": "Friend request sent!",
    "requestAccepted": "Friend request accepted!",
    "requestRejected": "Friend request rejected",
    "requestCancelled": "Friend request cancelled",
    "friendRemoved": "Friend removed",
    "searchFailed": "Failed to search users",
    "requestFailed": "Failed to send request",
    "acceptFailed": "Failed to accept request",
    "rejectFailed": "Failed to reject request",
    "cancelFailed": "Failed to cancel request",
    "removeFailed": "Failed to remove friend",
    "friendsCount": "{{count}} friends",
    "gamesCount": "{{count}} games",
    "alreadyFriends": "Friends"
  },
  "stats": {
    "statistics": "Statistics",
    "matchHistory": "Match History",
    "headToHead": "Head to Head",
    "gamesPlayed": "Games Played",
    "wins": "Wins",
    "losses": "Losses",
    "draws": "Draws",
    "winRate": "Win Rate",
    "rating": "Rating",
    "peakRating": "Peak Rating",
    "peak": "Peak",
    "winStreak": "Win Streak",
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "performance": "Performance",
    "achievements": "Achievements",
    "currentRating": "Current Rating",
    "totalGames": "Total Games",
    "noGames": "No games played yet",
    "moves": "moves",
    "won": "Won",
    "lost": "Lost",
    "draw": "Draw",
    "overall": "Overall Record",
    "yourWins": "Your Wins",
    "theirWins": "Their Wins",
    "totalGamesPlayed": "Total: {{count}} games",
    "recentGames": "Recent Games"
  },
  "support": {
    "title": "Support Center",
    "subtitle": "How can we help you today?",
    "tabs": {
      "docs": "Documentation",
      "faq": "FAQ",
      "contact": "Contact",
      "tickets": "My Tickets"
    },
    "categories": {
      "title": "Browse Documentation",
      "loading": "Loading documentation...",
      "loadError": "Failed to load categories",
      "articleCount": "{{count}} articles",
      "gettingStarted": "Getting Started",
      "features": "Features",
      "troubleshooting": "Troubleshooting",
      "account": "Account"
    },
    "docs": {
      "loading": "Loading document...",
      "loadError": "Failed to load document",
      "backToList": "Back to documentation"
    },
    "search": {
      "placeholder": "Search documentation...",
      "noResults": "No results found"
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "loading": "Loading FAQ...",
      "loadError": "Failed to load FAQ",
      "empty": "No FAQ items in this category",
      "categories": {
        "all": "All Topics",
        "general": "General",
        "billing": "Billing",
        "technical": "Technical",
        "features": "Features"
      }
    },
    "contact": {
      "voiceTitle": "Voice Support",
      "voiceDescription": "Click the avatar button or say \"Jarvis\" to start a voice conversation with our AI assistant.",
      "ticketTitle": "Create Support Ticket",
      "ticketDescription": "Need human assistance? Create a support ticket and our team will respond within 24 hours.",
      "createTicket": "Create Ticket",
      "emailTitle": "Email Support",
      "emailDescription": "Prefer email? Reach us at support@bayit.tv for any questions or concerns."
    },
    "ticket": {
      "title": "Create Support Ticket",
      "subject": "Subject",
      "subjectPlaceholder": "Brief description of your issue",
      "message": "Message",
      "messagePlaceholder": "Describe your issue in detail...",
      "categoryLabel": "Category",
      "priorityLabel": "Priority",
      "submit": "Submit Ticket",
      "category": {
        "billing": "Billing",
        "technical": "Technical",
        "feature": "Feature Request",
        "general": "General"
      },
      "priority": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "urgent": "Urgent"
      },
      "status": {
        "open": "Open",
        "in_progress": "In Progress",
        "resolved": "Resolved",
        "closed": "Closed"
      },
      "created": "Created",
      "error": {
        "required": "Please fill in all required fields",
        "submit": "Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "My Support Tickets",
      "loading": "Loading tickets...",
      "loadError": "Failed to load tickets",
      "empty": "No support tickets yet",
      "emptyFilter": "No tickets with this status",
      "create": "New Ticket",
      "createFirst": "Create Your First Ticket",
      "filter": {
        "all": "All",
        "open": "Open",
        "inProgress": "In Progress",
        "resolved": "Resolved"
      }
    },
    "voice": {
      "title": "Voice Assistant",
      "listening": "I'm listening...",
      "thinking": "Let me think about that...",
      "speaking": "Speaking...",
      "error": "Sorry, I didn't catch that. Try again?",
      "ready": "What would you like to know?",
      "listeningNow": "Listening...",
      "wakeWordHint": "Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "Your Guide"
    }
  },
  "jerusalem": {
    "title": "Jerusalem Connection",
    "subtitle": "Stay connected to the heart of Israel",
    "noContent": "No Jerusalem content available",
    "sources": "Sources",
    "kotelLive": "Western Wall Live",
    "categories": {
      "kotel": "Western Wall",
      "idf-ceremony": "IDF Ceremonies",
      "diaspora-connection": "Diaspora Connection",
      "holy-sites": "Holy Sites",
      "jerusalem-events": "Jerusalem Events",
      "general": "Jerusalem"
    }
  },
  "telAviv": {
    "title": "Tel Aviv Connection",
    "subtitle": "The city that never stops",
    "noContent": "No Tel Aviv content available",
    "sources": "Sources",
    "beachLive": "Beach Webcam",
    "categories": {
      "beaches": "Beaches",
      "nightlife": "Nightlife",
      "culture": "Culture & Art",
      "music": "Music Scene",
      "food": "Food & Dining",
      "tech": "Tech & Startups",
      "events": "Events",
      "general": "Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "Welcome to Voice Control",
      "description": "Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "Voice Commands",
      "voiceCommandsDesc": "Navigate, search, and control playback with natural speech",
      "tts": "Text-to-Speech",
      "ttsDesc": "Hear responses and content descriptions read aloud",
      "wakeWord": "Wake Word",
      "wakeWordDesc": "Say 'Bayit' to activate voice control anytime"
    },
    "getStarted": "Get Started",
    "permissions": {
      "title": "Microphone Access",
      "description": "Voice control requires microphone access to hear your commands",
      "privacy": "Your voice data is processed securely and never stored"
    },
    "permissionsGranted": "Microphone access granted",
    "permissionRequired": {
      "title": "Permission Required",
      "message": "Please enable microphone access in your device settings to use voice control"
    },
    "grantPermissions": "Grant Permissions",
    "testWakeWord": {
      "title": "Test Wake Word",
      "description": "Say 'Bayit' to test voice activation",
      "success": "Great! Voice activation is working"
    },
    "startTest": "Start Test",
    "complete": {
      "title": "You're All Set!",
      "description": "Voice control is now enabled. Try these commands:",
      "tryCommands": "Try These Commands",
      "examples": {
        "search": "\"Search for Fauda\"",
        "play": "\"Play the news\"",
        "navigate": "\"Go to Live TV\"",
        "control": "\"Pause\" or \"Volume up\""
      },
      "startUsing": "Start Using Voice Control"
    },
    "skip": "Skip for now",
    "buttons": {
      "back": "Back"
    },
    "completion": {
      "message": "Voice features are ready to use.",
      "title": "Voice Setup Complete"
    },
    "title": "Voice Setup",
    "training": {
      "message": "Read the phrases aloud to train voice recognition.",
      "title": "Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "Movies",
      "series": "Series",
      "kids": "Kids",
      "youngsters": "Youngsters",
      "music": "Music",
      "documentaries": "Documentaries",
      "podcasts": "Podcasts",
      "live": "Live TV"
    },
    "subcategories": {
      "learning-hebrew": "Learning Hebrew",
      "learning-hebrew.description": "Learning to read, write and vocabulary in Hebrew for kids",
      "young-science": "Young Science",
      "young-science.description": "Experiments and scientific explanations adapted for children",
      "math-fun": "Fun Math",
      "math-fun.description": "Learning numbers and arithmetic in a fun and playful way",
      "nature-animals": "Nature & Animals",
      "nature-animals.description": "The world of animals and nature for curious children",
      "interactive": "Interactive",
      "interactive.description": "Interactive and participatory content for children",
      "hebrew-songs": "Hebrew Songs",
      "hebrew-songs.description": "Classic and new Israeli children's songs",
      "nursery-rhymes": "Nursery Rhymes",
      "nursery-rhymes.description": "Songs and melodies for toddlers and babies",
      "kids-movies": "Kids Movies",
      "kids-movies.description": "Full-length movies suitable for children",
      "kids-series": "Kids Series",
      "kids-series.description": "Animated series and TV shows for children",
      "jewish-holidays": "Jewish Holidays",
      "jewish-holidays.description": "Content about Jewish holidays and traditions for children",
      "torah-stories": "Torah Stories",
      "torah-stories.description": "Stories from the Torah and Jewish tradition",
      "bedtime-stories": "Bedtime Stories",
      "bedtime-stories.description": "Relaxing stories for bedtime",
      "tiktok-trends": "TikTok Trends",
      "tiktok-trends.description": "Hot trends and challenges on TikTok",
      "viral-videos": "Viral Videos",
      "viral-videos.description": "Popular viral videos on social media",
      "memes": "Memes",
      "memes.description": "Funny memes and internet culture",
      "israel-news": "Israel News",
      "israel-news.description": "Israel news adapted for teens",
      "world-news": "World News",
      "world-news.description": "International news for youth",
      "science-news": "Science News",
      "science-news.description": "Scientific discoveries and technological innovation",
      "sports-news": "Sports News",
      "sports-news.description": "Sports updates and game results",
      "music-culture": "Music Culture",
      "music-culture.description": "Music scene, artists and festivals",
      "film-culture": "Film Culture",
      "film-culture.description": "Cinema, series and reviews",
      "art-culture": "Art Culture",
      "art-culture.description": "Art, galleries and creativity",
      "food-culture": "Food Culture",
      "food-culture.description": "Cooking, recipes and food culture",
      "study-help": "Study Help",
      "study-help.description": "Help with exams, summaries and test prep",
      "career-prep": "Career Prep",
      "career-prep.description": "University and career preparation",
      "life-skills": "Life Skills",
      "life-skills.description": "Life skills, money management and independence",
      "teen-movies": "Teen Movies",
      "teen-movies.description": "Recommended movies for teenagers",
      "teen-series": "Teen Series",
      "teen-series.description": "Popular series for teenagers",
      "gaming": "Gaming",
      "gaming.description": "Video games, e-sports and gaming",
      "coding": "Coding",
      "coding.description": "Programming, coding and software development",
      "gadgets": "Gadgets",
      "gadgets.description": "Gadgets, technology and reviews",
      "bar-bat-mitzvah": "Bar/Bat Mitzvah",
      "bar-bat-mitzvah.description": "Preparation and celebrations for Bar/Bat Mitzvah",
      "teen-torah": "Teen Torah",
      "teen-torah.description": "Torah classes and weekly portion for teens",
      "jewish-history": "Jewish History",
      "jewish-history.description": "History of the Jewish people"
    }
  },
  "passkey": {
    "manager": {
      "title": "Passkeys",
      "subtitle": "Manage your passkeys for secure content access"
    },
    "unsupported": "Passkeys are not supported on this device",
    "fetchError": "Failed to load passkeys",
    "registerError": "Failed to register passkey",
    "deleteError": "Failed to delete passkey",
    "cancelled": "Passkey operation was cancelled",
    "noPasskeys": "No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "Unknown Device",
    "created": "Created",
    "lastUsed": "Last used",
    "never": "Never",
    "addPasskey": "Add Passkey",
    "deleteConfirmTitle": "Delete Passkey?",
    "deleteConfirmText": "This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "Unlock",
    "unlockContent": "Unlock Private Content",
    "unlockDescription": "Use your passkey to access private movies and series",
    "auth": {
      "title": "Unlock Content",
      "description": "Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "Unlock with Passkey",
      "authenticating": "Authenticating...",
      "success": "Content Unlocked!",
      "cancelled": "Authentication was cancelled",
      "error": "Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "Use Phone to Unlock",
      "scanWithPhone": "Scan with your phone",
      "instruction": "Open the camera on your phone and scan the QR code to authenticate",
      "error": "Failed to generate QR code",
      "expired": "QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "Session not found",
      "session_different_partner": "Session belongs to different partner",
      "session_invalid_status": "Session is {status}, cannot add transcript",
      "max_sessions_reached": "Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "Invalid API key",
      "missing_api_key": "Missing {header} header",
      "capability_disabled": "Capability '{capability}' is currently disabled",
      "capability_not_enabled": "Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "Partner not found",
      "partner_registration_failed": "Failed to register partner",
      "no_updates_provided": "No updates provided",
      "webhook_config_failed": "Failed to configure webhook",
      "webhook_url_not_configured": "Webhook URL not configured",
      "webhook_secret_not_configured": "Webhook secret not configured",
      "search_failed": "Search failed",
      "indexing_failed": "Indexing failed",
      "detection_failed": "Detection failed",
      "explanation_failed": "Failed to get explanation",
      "reference_not_found": "Reference '{reference_id}' not found",
      "enrichment_failed": "Enrichment failed",
      "get_references_failed": "Failed to get references",
      "create_session_failed": "Failed to create session",
      "add_transcript_failed": "Failed to add transcript",
      "generate_recap_failed": "Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "Home",
      "features": "Features",
      "solutions": "Solutions",
      "pricing": "Pricing",
      "demo": "Live Demo",
      "contact": "Contact",
      "getStarted": "Get Started"
    },
    "hero": {
      "ctaExplore": "Explore Features",
      "ctaDemo": "Request Demo"
    },
    "cta": {
      "title": "Ready to Get Started?",
      "subtitle": "Let's discuss how we can help transform your business",
      "button": "Contact Us"
    },
    "contactPage": {
      "title": "Get In Touch",
      "subtitle": "Interested in our solutions? Let's talk",
      "formTitle": "Send Us a Message",
      "infoTitle": "Contact Information",
      "form": {
        "name": "Full Name",
        "email": "Email Address",
        "company": "Company Name",
        "phone": "Phone Number",
        "message": "Your Message",
        "messagePlaceholder": "Tell us about your needs..."
      },
      "submit": "Send Message",
      "sending": "Sending...",
      "success": "Message sent successfully! We'll get back to you soon.",
      "error": "Failed to send message. Please try again.",
      "scheduleTitle": "Prefer to Schedule a Call?",
      "scheduleSubtitle": "Book a personalized demo with our team",
      "scheduleCta": "Schedule Demo Call"
    },
    "pricingPage": {
      "title": "Affordable",
      "titleHighlight": "Pricing Plans",
      "subtitle": "Choose the plan that fits your needs",
      "comparisonTitle": "Feature Comparison",
      "faqTitle": "Frequently Asked Questions",
      "faq": {
        "q1": "How is pricing calculated?",
        "a1": "Pricing is based on your specific needs and usage. Contact us for a custom quote.",
        "q2": "Can I upgrade my plan later?",
        "a2": "Yes, you can upgrade at any time. We'll help migrate your data seamlessly.",
        "q3": "What support is included?",
        "a3": "All plans include email support. Professional and Enterprise plans include priority support with dedicated account managers."
      },
      "professional": {
        "name": "Professional",
        "price": "Contact for Quote",
        "priceNote": "Custom pricing",
        "description": "For growing businesses with advanced needs",
        "cta": "Get Quote"
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Custom",
        "priceNote": "Volume-based",
        "description": "For large organizations and enterprise deployments",
        "cta": "Contact Sales"
      },
      "ctaTitle": "Ready to Get Started?",
      "ctaSubtitle": "Let's discuss your needs and find the perfect plan",
      "ctaButton": "Contact Sales"
    },
    "featuresPage": {
      "title": "Powerful",
      "titleHighlight": "Features",
      "subtitle": "Everything you need to succeed",
      "techSpecsTitle": "Technical Specifications",
      "workflowTitle": "How It Works",
      "workflow": {
        "s1": {
          "title": "Import",
          "description": "Upload and organize your content"
        },
        "s2": {
          "title": "Configure",
          "description": "Set up your preferences and settings"
        },
        "s3": {
          "title": "Deploy",
          "description": "Go live with your solution"
        },
        "s4": {
          "title": "Monitor",
          "description": "Track performance and optimize"
        }
      },
      "ctaTitle": "Ready to Explore Features?",
      "ctaSubtitle": "See all features in action with a personalized demo",
      "ctaButton": "Schedule Demo"
    },
    "demoPage": {
      "title": "See Our",
      "titleHighlight": "Platform",
      "subtitle": "Experience the power of our solution",
      "scheduleCta": "Schedule Live Demo",
      "stepsTitle": "How It Works",
      "steps": {
        "analyze": {
          "title": "Analyze",
          "description": "Track and improve performance"
        }
      },
      "featuresTitle": "Platform Highlights",
      "platformsTitle": "Available On",
      "ctaTitle": "Ready for Your Custom Demo?",
      "ctaSubtitle": "Schedule a personalized demonstration tailored to your needs",
      "ctaButton": "Schedule Demo"
    },
    "workflow": {
      "sectionTitle": "Intelligent Workflow",
      "sectionSubtitle": "Streamlined process in 4 steps",
      "step1": {
        "title": "Setup",
        "description": "Configure your account and preferences"
      },
      "step2": {
        "title": "Configure",
        "description": "Customize settings for your needs"
      },
      "step3": {
        "title": "Deploy",
        "description": "Launch your solution"
      },
      "step4": {
        "title": "Monitor",
        "description": "Track performance and optimize"
      }
    }
  },
  "trivia": {
    "didYouKnow": "Did You Know?",
    "dismissHint": "Dismiss trivia fact",
    "settings": {
      "displayLanguages": "Display Languages",
      "languageHint": "Select 1-3 languages to display for each fact",
      "language": "language",
      "selectLanguage": "Select this language",
      "deselectLanguage": "Deselect this language",
      "enableDescription": "Show trivia questions while watching content.",
      "enableTrivia": "Enable Trivia",
      "title": "Trivia Settings"
    },
    "aiTrivia": "AI Trivia",
    "tellMeMore": "Tell me more",
    "more": "More",
    "follow_up": "Follow up"
  },
  "auth": {
    "loginRequired": "Login Required",
    "loginToWatch": "Please sign in to watch {{title}}",
    "login": "Login",
    "signUp": "Sign Up",
    "biometricEnrollEnable": "Enable",
    "biometricEnrollMessage": "Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "Skip",
    "biometricEnrollTitle": "Enable Biometric Sign-In",
    "biometricSignIn": "Sign in with Biometrics",
    "signOut": "Sign Out",
    "register": {
      "createAccount": "Create Account",
      "email": "Email",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "register": "Register",
      "alreadyHaveAccount": "Already have an account? Sign In",
      "passwordStrength": {
        "weak": "Weak",
        "medium": "Medium",
        "strong": "Strong"
      }
    }
  },
  "recording": {
    "stop": "Stop Recording",
    "start": "Start Recording"
  },
  "discover": {
    "title": "Discover",
    "subtitle": "Explore 19 AI-powered features",
    "description": "Bayit+ uses AI to enhance your viewing, listening, and learning experience. Discover what's available on your platform.",
    "featureCount": "{{count}} features",
    "tryIt": "Try It",
    "startWalkthrough": "Start Walkthrough",
    "availableOn": "Available on",
    "prerequisites": "Prerequisites",
    "setup": "Set Up",
    "error": {
      "fetchFailed": "Failed to load Discover features. Please try again.",
      "unknownFeature": "Feature not found.",
      "featureDisabled": "This feature is currently disabled."
    },
    "availability": {
      "ready": "Ready",
      "setupNeeded": "Setup Needed",
      "premiumRequired": "Premium Required",
      "notAvailable": "Not Available",
      "platformOnly": "Other Platform"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "Watching Movies",
      "watching_live_tv": "Watching Live TV",
      "learn_hebrew": "Learn Hebrew",
      "search_discovery": "Search & Discovery",
      "chat_assistants": "Chat Assistants"
    },
    "feature": {
      "pause_ask": {
        "name": "Pause & Ask",
        "tagline": "Pause any scene and ask your AI companion about it",
        "description": "While watching, pause the video and ask questions about the current scene. Your AI character will explain cultural references, translate dialogue, or discuss the plot."
      },
      "interactive_subtitles": {
        "name": "Interactive Subtitles",
        "tagline": "Tap any subtitle word for instant translation and context",
        "description": "Click on any word in the subtitles to see its translation, hear pronunciation, and get usage examples. Build vocabulary while watching your favorite shows."
      },
      "vocabulary": {
        "name": "Vocabulary Builder",
        "tagline": "Learn new words from the shows you watch",
        "description": "Automatically collect new Hebrew words from subtitles. Review flashcards, track progress, and build your vocabulary through content you enjoy."
      },
      "vod_moments": {
        "name": "VOD Moments",
        "tagline": "AI-curated highlights from your favorite content",
        "description": "Get AI-generated highlight clips and key moments from movies and shows. Share memorable scenes and revisit the best parts."
      },
      "cultural_context": {
        "name": "Cultural Context",
        "tagline": "Understand the cultural background behind every scene",
        "description": "Get real-time cultural annotations explaining Israeli customs, holidays, humor, and social norms that appear in the content you watch."
      },
      "bilingual_bridge": {
        "name": "Bilingual Bridge",
        "tagline": "Side-by-side Hebrew-English learning while watching",
        "description": "View dual-language subtitles with highlighted vocabulary. Toggle between Hebrew and your native language to build comprehension naturally."
      },
      "ai_companion": {
        "name": "AI Companion",
        "tagline": "Your personal AI guide through Israeli content",
        "description": "An AI character that watches along with you, offering commentary, answering questions, and helping you understand the nuances of Israeli media."
      },
      "live_dubbing": {
        "name": "Live Dubbing",
        "tagline": "Real-time AI dubbing of live Israeli TV channels",
        "description": "Watch live Israeli TV with AI-powered real-time dubbing in your preferred language. Experience news, talk shows, and entertainment without language barriers."
      },
      "live_subtitles": {
        "name": "Live Subtitles",
        "tagline": "Real-time AI subtitles for live broadcasts",
        "description": "Get AI-generated subtitles in real-time as you watch live Israeli TV. Choose your preferred language for instant translation of live content."
      },
      "live_trivia": {
        "name": "Live Trivia",
        "tagline": "Play trivia games based on what's airing live",
        "description": "AI detects topics from live broadcasts and generates trivia questions in real-time. Compete with friends and learn about Israeli culture while watching TV."
      },
      "catch_up": {
        "name": "Catch Up",
        "tagline": "AI summaries of what you missed on live TV",
        "description": "Missed part of a live broadcast? Get AI-generated summaries that catch you up on what happened, with key moments highlighted for quick review."
      },
      "scene_search": {
        "name": "Scene Search",
        "tagline": "Search for specific scenes across all content",
        "description": "Describe a scene you remember and AI will find it across all available content. Search by dialogue, visual elements, or plot descriptions."
      },
      "phonetic_mirror": {
        "name": "Phonetic Mirror",
        "tagline": "Practice Hebrew pronunciation with AI feedback",
        "description": "Record yourself speaking Hebrew and get instant AI feedback on pronunciation. Compare your speech with native speakers and track improvement over time."
      },
      "talk_back": {
        "name": "Talk Back",
        "tagline": "Have voice conversations in Hebrew with your AI character",
        "description": "Practice conversational Hebrew by talking with your AI character. Get real-time feedback on grammar, vocabulary, and pronunciation in natural dialogue."
      },
      "interactive_mission": {
        "name": "Interactive Missions",
        "tagline": "Fun Hebrew learning challenges with AI guidance",
        "description": "Complete AI-guided missions that combine watching content with Hebrew learning exercises. Earn rewards and track your language journey."
      },
      "glossary": {
        "name": "Personal Glossary",
        "tagline": "Your personalized Hebrew dictionary built from content",
        "description": "All the Hebrew words you've encountered and saved, organized by category, frequency, and mastery level. Review and practice anytime."
      },
      "llm_search": {
        "name": "AI Search",
        "tagline": "Find content with natural language queries",
        "description": "Search the entire Bayit+ library using natural language. Ask for 'funny Israeli comedies about family' or 'documentaries about Tel Aviv' and get AI-curated results."
      },
      "proactive_voice": {
        "name": "Proactive Voice",
        "tagline": "Voice-first AI assistant that anticipates your needs",
        "description": "An AI assistant that listens and proactively offers relevant content suggestions, translations, and learning opportunities based on what you're watching."
      },
      "chatbot": {
        "name": "Bayit Chat",
        "tagline": "Chat with AI about anything related to Israeli content",
        "description": "Ask questions about Israeli culture, get content recommendations, practice Hebrew, or discuss what you've been watching. Your AI companion is always available."
      }
    },
    "prereq": {
      "avatar": "Create your AI character",
      "subscription": "Premium subscription required",
      "microphone": "Microphone access needed",
      "contentType": "Select your content preferences",
      "preference": "Set your language preferences",
      "voiceClone": "Set up your voice clone"
    },
    "walkthrough": {
      "tryItNow": "Try it now",
      "watchDemo": "Watch demo",
      "skip": "Skip",
      "next": "Next",
      "done": "Done",
      "complete": "Walkthrough complete",
      "stepCounter": "{{current}} of {{total}}",
      "pause_ask": {
        "step1": "Navigate to a movie with interactive moments",
        "step2": "Pause the movie during a scene",
        "step3": "Tap the Ask a Character button",
        "step4": "Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "Start playing a movie with subtitles",
        "step2": "Tap the Interactive button in the control bar",
        "step3": "Select your subtitle language",
        "step4": "Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "Open a movie with interactive subtitles enabled",
        "step2": "Tap a word you want to learn",
        "step3": "Tap Save to Vocabulary",
        "step4": "Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "Start watching a movie with interactive moments",
        "step2": "Wait for an interactive prompt to appear",
        "step3": "See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "Play a movie with Hebrew dialogue",
        "step2": "Tap on a subtitle with cultural significance",
        "step3": "Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "Open a movie with bilingual support",
        "step2": "Select the bilingual subtitle mode",
        "step3": "Tap a highlighted phrase to see the translation",
        "step4": "Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "Start watching any movie",
        "step2": "Tap the AI Companion button",
        "step3": "Type a question about the movie",
        "step4": "Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "Navigate to a live TV channel",
        "step2": "Tap the dubbing button in the control bar",
        "step3": "Select your preferred language",
        "step4": "Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "Navigate to a live TV channel",
        "step2": "Tap the subtitles button",
        "step3": "Select your subtitle language",
        "step4": "Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "Navigate to a live TV channel",
        "step2": "Tap the trivia button",
        "step3": "Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "Navigate to a live broadcast",
        "step2": "Select the catch-up option",
        "step3": "Tap to generate an AI summary",
        "step4": "Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "Navigate to a recorded broadcast",
        "step2": "Type what you are looking for",
        "step3": "Tap on the matching scene",
        "step4": "Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "Open the Phonetic Mirror in Zeh Ani",
        "step2": "Read the Hebrew phrase shown",
        "step3": "Speak the phrase into your microphone",
        "step4": "Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "Open Talk Back in Zeh Ani",
        "step2": "Listen to your avatar speak Hebrew",
        "step3": "Respond in Hebrew using your microphone",
        "step4": "Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "Open Interactive Missions",
        "step2": "Select a mission level",
        "step3": "Follow the AI-guided exercises",
        "step4": "Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "Open the Hebrew Glossary",
        "step2": "Search for a Hebrew word",
        "step3": "Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "Open the Search tab",
        "step2": "Type a natural language query",
        "step3": "Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "Open the Voice Suggestions feature",
        "step2": "Tap and hold to speak",
        "step3": "Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "Open the AI Assistant",
        "step2": "Type your question or request",
        "step3": "Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "Bring Your Own Content",
      "subtitle": "Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "Connect Sources",
      "aiFeatures": {
        "dubbing": "AI Dubbing available",
        "subtitles": "Live Subtitles available"
      }
    },
    "pageSubtitle": "Bring Your Own Content - add IPTV and streaming sources",
    "addSource": "Add Source",
    "sync": "Sync",
    "remove": "Remove",
    "channelCount": "{{count}} channels",
    "empty": {
      "title": "No Sources Added",
      "subtitle": "Add your IPTV, Xtream, or streaming sources to watch your own content alongside Bayit+"
    },
    "source": {
      "iptv": "IPTV Source",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "Add IPTV Source",
      "subtitle": "Enter a URL to an M3U or M3U8 playlist file",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "Validate",
      "add": "Add Source"
    },
    "addXtream": {
      "title": "Connect Xtream Codes",
      "subtitle": "Enter your Xtream Codes server credentials",
      "serverUrl": "Server URL",
      "username": "Username",
      "password": "Password",
      "connect": "Connect"
    },
    "preview": {
      "title": "Preview",
      "channelCount": "{{count}} channels found"
    },
    "providers": {
      "title": "Popular Providers"
    },
    "wizard": {
      "step1": "Add Source",
      "step2": "Processing",
      "step3": "Review",
      "selectSource": "Select Source Type"
    },
    "normalization": {
      "title": "Processing Your Content",
      "total": "{{count}} total channels",
      "matched": "{{count}} matched",
      "stage": {
        "parsing": "Parsing playlist...",
        "matching": "Matching channels...",
        "enriching": "Enriching metadata...",
        "finalizing": "Finalizing..."
      }
    },
    "review": {
      "title": "Review Imported Content",
      "subtitle": "{{matched}} matched, {{unmatched}} unmatched channels",
      "matchedChannels": "Matched Channels",
      "unmatchedChannels": "Unmatched Channels",
      "apply": "Apply & Import"
    },
    "error": {
      "urlRequired": "Please enter a URL",
      "noChannels": "No channels found in this playlist",
      "invalidUrl": "Could not load playlist from this URL",
      "allFieldsRequired": "All fields are required",
      "enrichFailed": "Failed to analyze source",
      "syncFailed": "Failed to sync source",
      "normalizationFailed": "Content processing failed",
      "normalizationPollFailed": "Lost connection during processing"
    },
    "plex": {
      "connectPlex": "Connect Plex",
      "enterCodeAt": "Enter this code at",
      "waitingForAuth": "Waiting for authorization...",
      "selectServer": "Select a Plex server",
      "connecting": "Connecting to {{serverName}}...",
      "connected": "Connected",
      "label": "Plex"
    },
    "settings": {
      "title": "Your Content Sources",
      "refresh": "Refresh",
      "noSources": "No content sources connected",
      "noSourcesSubtitle": "Connect your Plex, YouTube, IPTV, or Xtream provider",
      "removeSource": "Remove source",
      "plexSubtitle": "Stream from your Plex media server",
      "youtubeSubtitle": "Access your YouTube library",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "Add M3U playlist or Xtream Codes",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Welcome to Bayit+",
      "subtitle": "Your AI-powered gateway to Israeli content, culture, and language learning",
      "getStarted": "Get Started"
    },
    "highlight": {
      "dubbing": "Live AI Dubbing",
      "subtitles": "Interactive Subtitles",
      "ai": "AI Companions",
      "learning": "Hebrew Learning"
    },
    "voice": {
      "title": "Voice Setup",
      "subtitle": "Enable your microphone for voice commands, Hebrew pronunciation practice, and hands-free navigation",
      "enable": "Enable Microphone",
      "granted": "Microphone enabled successfully"
    },
    "tour": {
      "done": "Done"
    },
    "demo": {
      "dubbing": {
        "title": "Live AI Dubbing",
        "description": "Watch Israeli TV with real-time AI dubbing in your preferred language",
        "hebrew": "Hebrew",
        "english": "English"
      },
      "subtitles": {
        "title": "Interactive Subtitles",
        "description": "Tap any word in subtitles for instant translation and pronunciation",
        "sample": "The family gathered for Shabbat dinner",
        "word": "Shabbat",
        "translation": "Sabbath - weekly day of rest"
      },
      "interaction": {
        "title": "AI Character Interaction",
        "description": "Pause any scene and ask your AI companion about cultural context",
        "userMsg": "What holiday are they celebrating?",
        "aiMsg": "They are celebrating Sukkot, the Festival of Tabernacles. The temporary hut you see is called a sukkah."
      },
      "trivia": {
        "title": "Live Trivia",
        "description": "AI generates trivia questions from what's airing live. Compete and learn!",
        "question": "What is the official language of Israel?",
        "optionA": "Arabic",
        "optionB": "Hebrew",
        "optionC": "English"
      },
      "catchup": {
        "title": "Smart Catch Up",
        "description": "Missed part of a live broadcast? AI summarizes what you missed",
        "missed": "Missed",
        "summary": "AI Summary",
        "live": "Live Now"
      },
      "byoc": {
        "title": "Bring Your Own Content",
        "description": "Import your IPTV sources and watch them alongside Bayit+ content",
        "step1": "Add Source",
        "step2": "AI Enrichment",
        "step3": "Watch"
      },
      "zehAni": {
        "title": "Create Your AI Character",
        "description": "Generate a personalized AI avatar that learns with you",
        "generated": "AI Avatar"
      }
    }
  },
  "dm": {
    "title": "Messages",
    "conversations": "Conversations",
    "conversation": "Conversation",
    "empty": {
      "title": "No Messages Yet",
      "subtitle": "Start a conversation with a friend"
    },
    "input": {
      "placeholder": "Type a message...",
      "send": "Send"
    },
    "translate": "Translate",
    "react": "React",
    "read": "Read",
    "sent": "Sent",
    "loadMore": "Load Earlier Messages",
    "startConversation": "Send a message to start the conversation",
    "reaction": {
      "like": "Like",
      "love": "Love",
      "laugh": "Haha",
      "surprise": "Wow",
      "sad": "Sad"
    },
    "error": {
      "fetchFailed": "Failed to load messages",
      "sendFailed": "Failed to send message"
    }
  },
  "household": {
    "empty": {
      "title": "No Household Yet",
      "subtitle": "Create a household to manage your family"
    },
    "create": {
      "namePlaceholder": "Household name",
      "button": "Create Household"
    },
    "members": "Members",
    "role": {
      "owner": "Owner",
      "guardian": "Guardian",
      "child": "Child"
    },
    "invite": {
      "title": "Invite Members",
      "emailPlaceholder": "Email address",
      "send": "Send Invite",
      "pending": "Pending Invitations"
    },
    "removeMember": "Remove",
    "error": {
      "fetchFailed": "Failed to load household",
      "createFailed": "Failed to create household",
      "updateFailed": "Failed to update household",
      "deleteFailed": "Failed to delete household",
      "inviteFailed": "Failed to send invitation",
      "removeFailed": "Failed to remove member"
    }
  },
  "aiChat": {
    "retryButton": "Retry",
    "sendButton": "Send",
    "title": "AI Chat",
    "voiceButton": "Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "Back"
    },
    "completion": {
      "message": "You're all set! Start exploring AI features.",
      "title": "Setup Complete"
    },
    "permissions": {
      "description": "Grant permissions to enable AI features like voice and camera.",
      "title": "Permissions"
    },
    "personalization": {
      "description": "Tell us your preferences to personalize your AI experience.",
      "title": "Personalization"
    },
    "title": "AI Setup",
    "welcome": {
      "description": "Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "Device authorized",
  "auth_device_code_expired": "Code expired",
  "auth_device_get_new_code": "Get new code",
  "auth_device_manual_login": "Sign in manually",
  "auth_device_visit_uri": "Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "Tap to speak",
    "title": "Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "Dubbed Audio",
      "originalAudio": "Original Audio",
      "title": "Audio Mixer"
    },
    "settings_title": "Dubbing Settings",
    "target_language": "Target Language",
    "voiceSelector": {
      "selected": "Selected",
      "subtitle": "Choose a voice for dubbing",
      "title": "Voice Selection"
    }
  },
  "go_back": "Go Back",
  "miniPlayer": {
    "closePlayer": "Close Player",
    "skipBackward": "Skip Backward",
    "skipForward": "Skip Forward"
  },
  "retry": "Retry",
  "search_hint": "Search channels, movies, shows...",
  "search_no_results": "No results found",
  "search_prompt": "What are you looking for?",
  "subscription_required": "Subscription Required",
  "subscription_upsell_tv": "Upgrade to watch on TV",
  "talkback": {
    "title": "Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "Voice Assistant",
    "modal": {
      "cancel": "Cancel",
      "setupMessage": "Set up voice recognition to use the voice assistant.",
      "setupRequired": "Setup Required",
      "startSetup": "Start Setup",
      "title": "Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "Executing...",
    "listening": "Listening...",
    "noMatch": "No match found",
    "recognized": "Recognized"
  },
  "voiceDecision": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "matched": "Matched"
  },
  "voiceSearch": {
    "listening": "Listening...",
    "noResults": "No results found",
    "tapToSpeak": "Tap to speak",
    "title": "Voice Search"
  },
  "voiceSettings": {
    "language": "Language",
    "speechRate": "Speech Rate",
    "title": "Voice Settings",
    "ttsProvider": "TTS Provider",
    "voiceMode": "Voice Mode",
    "voiceSelection": "Voice Selection",
    "wakeWord": "Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "Back"
    },
    "calibration": {
      "description": "Speak normally to calibrate the microphone.",
      "listening": "Listening...",
      "micButton": "Start Recording",
      "resultTitle": "Calibration Result",
      "stopButton": "Stop Recording",
      "tapToStart": "Tap to start calibration",
      "title": "Microphone Calibration"
    },
    "complete": {
      "message": "Voice wizard setup is complete. You can now use voice features.",
      "title": "Setup Complete"
    },
    "language": {
      "description": "Select your preferred language for voice commands.",
      "title": "Voice Language"
    },
    "permission": {
      "description": "Microphone access is needed for voice features.",
      "granted": "Permission Granted",
      "requestButton": "Grant Permission",
      "title": "Microphone Permission"
    },
    "title": "Voice Wizard"
  },
  "watch_now": "Watch Now",
  "culture": {
    "title": "Israeli Culture",
    "description": "Jerusalem, Tel Aviv, and Israeli heritage",
    "shabbat": {
      "title": "Shabbat Mode",
      "enableShabbatMode": "Enable Shabbat Mode",
      "shabbatTimes": "Shabbat Times",
      "timesDescription": "Candle Lighting and Havdalah times will be displayed here",
      "aboutTitle": "About Shabbat Mode",
      "aboutDescription": "When enabled, Shabbat Mode will pause notifications, reduce screen brightness, and enable a simplified interface during Shabbat hours."
    },
    "judaism": {
      "holidaysAndTorah": "Holidays & Torah",
      "parashaOfTheWeek": "Parasha of the Week",
      "parashaDescription": "Weekly Torah reading and commentary"
    },
    "morning": {
      "title": "Morning Ritual",
      "description": "Start your day with intention and gratitude",
      "dailyInspiration": "Daily Inspiration",
      "dailyInspirationDescription": "Curated content for your morning routine",
      "modehAni": "Modeh Ani",
      "modehAniDescription": "Morning gratitude prayer",
      "netilatYadayim": "Netilat Yadayim",
      "netilatYadayimDescription": "Ritual hand washing",
      "shacharit": "Shacharit",
      "shacharitDescription": "Morning prayer service"
    },
    "glossary": {
      "termDetail": "Term Detail",
      "definition": "Definition",
      "pronunciation": "Pronunciation",
      "examples": "Examples"
    },
    "jerusalem": {
      "title": "Jerusalem"
    },
    "telaviv": {
      "title": "Tel Aviv"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "Zeh Ani",
      "biometricConsent": "Biometric Consent",
      "activeConsents": "{{count}} active consents",
      "magicMirror": "Magic Mirror",
      "magicMirrorDescription": "Daily greetings and face ID",
      "v2vPractice": "V2V Practice",
      "v2vPracticeDescription": "Voice-to-voice pronunciation",
      "avatar3d": "3D Avatar",
      "avatar3dDescription": "Your personalized avatar mesh",
      "movieInteractions": "Movie Interactions",
      "movieInteractionsDescription": "Browse and talk to movie characters",
      "contacts": "Contacts",
      "contactsDescription": "WhatsApp sharing contacts",
      "feedback": "Feedback",
      "feedbackDescription": "Share your experience",
      "consent": "Consent",
      "consentDescription": "Biometric consent management",
      "chess": "Chess",
      "chessDescription": "Play chess with friends and family"
    },
    "mirror": {
      "title": "Magic Mirror",
      "avatarContentDescription": "Avatar",
      "wordOfTheDay": "Word of the Day",
      "playLipsync": "Play Lipsync",
      "noAvatarYet": "No avatar yet",
      "noAvatarDescription": "Create a 3D avatar to see yourself in the story",
      "createAvatar": "Create Avatar"
    },
    "mode": {
      "title": "Avatar Mode",
      "enableAvatarMode": "Enable Avatar Mode",
      "enableDescription": "Show your avatar reacting to content",
      "avatarPreview": "Avatar Preview",
      "avatarPreviewContentDescription": "Avatar preview",
      "noAvatarConfigured": "No avatar configured",
      "reactionStyle": "Reaction Style"
    },
    "wardrobe": {
      "title": "Wardrobe",
      "equippedContentDescription": "Equipped"
    },
    "settings": {
      "title": "Avatar Settings",
      "privacy": "Privacy",
      "privateAvatarMode": "Private Avatar Mode",
      "privateAvatarDescription": "Hide your avatar from other users",
      "appearance": "Appearance",
      "enableAnimations": "Enable Animations",
      "animationsDescription": "Animate avatar movements and expressions",
      "availableOutfits": "Available Outfits"
    },
    "selfie": {
      "title": "Video Selfie",
      "camera": "Camera",
      "cameraPreview": "Camera Preview",
      "startRecording": "Start Recording",
      "stopRecording": "Stop Recording",
      "rec": "REC",
      "enterPin": "Enter your PIN to create avatar",
      "pinLabel": "PIN",
      "retake": "Retake",
      "creatingAvatar": "Creating your avatar...",
      "avatarCreated": "Avatar created successfully",
      "avatarPreviewContentDescription": "Avatar Preview",
      "createAnother": "Create Another"
    },
    "mesh": {
      "title": "3D Avatar",
      "meshViewer": "3D Mesh Viewer",
      "meshViewerDescription": "3D mesh viewer requires WebView or GLSurfaceView integration",
      "skinTone": "Skin Tone",
      "hairStyle": "Hair Style",
      "accessories": "Accessories",
      "saveChanges": "Save Changes"
    },
    "v2v": {
      "title": "Voice Practice",
      "nextPhrase": "Next Phrase",
      "stop": "Stop",
      "record": "Record",
      "mic": "MIC",
      "viewProgress": "View Progress",
      "analyzingPronunciation": "Analyzing pronunciation...",
      "pronunciationFeedback": "Pronunciation Feedback",
      "similarity": "Similarity: {{score}}%",
      "yourProgress": "Your Progress",
      "transforms": "Transforms: {{count}}",
      "improvement": "Improvement: {{score}}%",
      "continuePracticing": "Continue Practicing"
    },
    "characters": {
      "title": "Characters",
      "noCharactersFound": "No characters found for this movie",
      "characterCount": "{{count}} characters"
    },
    "interactions": {
      "title": "Movie Interactions",
      "noInteractableMovies": "No interactable movies available"
    },
    "feedbackInbox": {
      "title": "Feedback Inbox",
      "refreshContentDescription": "Refresh",
      "noFeedbackYet": "No feedback yet",
      "feedbackAppearHere": "Feedback from your contacts will appear here",
      "playVoiceMessage": "Play Voice Message"
    },
    "addContact": {
      "title": "Add Contact",
      "nameLabel": "Name",
      "phoneLabel": "Phone",
      "relationship": "Relationship",
      "language": "Language"
    },
    "avatar3d": {
      "title": "3D Avatar",
      "glbMeshViewer": "GLB Mesh Viewer",
      "controls": "Controls",
      "animate": "Animate",
      "vertices": "Vertices",
      "bones": "Bones",
      "blendShapes": "Blend Shapes",
      "hasGlb": "Has GLB",
      "status": "Status: {{value}}"
    }
  }
}
